//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase, HttpContext } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AgentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Suggest evidence-backed next requests for this claim
     * @return OK
     */
    getClaimAgentRecommendations(claimId: number, httpContext?: HttpContext): Observable<ClaimAgentRecommendationSetDto> {
        let url_ = this.baseUrl + "/api/agent/claims/{claimId}/agent/recommendations";
        if (claimId === undefined || claimId === null)
            throw new globalThis.Error("The parameter 'claimId' must be defined.");
        url_ = url_.replace("{claimId}", encodeURIComponent("" + claimId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaimAgentRecommendations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaimAgentRecommendations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimAgentRecommendationSetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimAgentRecommendationSetDto>;
        }));
    }

    protected processGetClaimAgentRecommendations(response: HttpResponseBase): Observable<ClaimAgentRecommendationSetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimAgentRecommendationSetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recheck recommendation evidence before starting a request
     * @return OK
     */
    validateClaimAgentRecommendation(claimId: number, id: string, body: ClaimAgentRecommendationSelectionRequest, httpContext?: HttpContext): Observable<ClaimAgentRecommendationDto> {
        let url_ = this.baseUrl + "/api/agent/claims/{claimId}/agent/recommendations/{id}/selection";
        if (claimId === undefined || claimId === null)
            throw new globalThis.Error("The parameter 'claimId' must be defined.");
        url_ = url_.replace("{claimId}", encodeURIComponent("" + claimId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateClaimAgentRecommendation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateClaimAgentRecommendation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimAgentRecommendationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimAgentRecommendationDto>;
        }));
    }

    protected processValidateClaimAgentRecommendation(response: HttpResponseBase): Observable<ClaimAgentRecommendationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimAgentRecommendationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Dismiss or snooze a recommendation for the current user
     * @return No Content
     */
    dismissClaimAgentRecommendation(claimId: number, id: string, body: ClaimAgentRecommendationFeedbackRequest, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/agent/claims/{claimId}/agent/recommendations/{id}/feedback";
        if (claimId === undefined || claimId === null)
            throw new globalThis.Error("The parameter 'claimId' must be defined.");
        url_ = url_.replace("{claimId}", encodeURIComponent("" + claimId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissClaimAgentRecommendation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissClaimAgentRecommendation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDismissClaimAgentRecommendation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * List Claim Agent developer tools
     * @return OK
     */
    getClaimAgentDeveloperInfo(httpContext?: HttpContext): Observable<ClaimAgentDeveloperInfoResponse> {
        let url_ = this.baseUrl + "/api/agent/claim-agent/developer-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaimAgentDeveloperInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaimAgentDeveloperInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimAgentDeveloperInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimAgentDeveloperInfoResponse>;
        }));
    }

    protected processGetClaimAgentDeveloperInfo(response: HttpResponseBase): Observable<ClaimAgentDeveloperInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimAgentDeveloperInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Load persisted claim agent conversation state
     * @return OK
     */
    getClaimAgentConversation(claimId: number, httpContext?: HttpContext): Observable<ClaimAgentConversationResponse> {
        let url_ = this.baseUrl + "/api/agent/claims/{claimId}/agent/conversation";
        if (claimId === undefined || claimId === null)
            throw new globalThis.Error("The parameter 'claimId' must be defined.");
        url_ = url_.replace("{claimId}", encodeURIComponent("" + claimId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaimAgentConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaimAgentConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimAgentConversationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimAgentConversationResponse>;
        }));
    }

    protected processGetClaimAgentConversation(response: HttpResponseBase): Observable<ClaimAgentConversationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimAgentConversationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Clear persisted claim agent conversation state
     * @return No Content
     */
    clearClaimAgentConversation(claimId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/agent/claims/{claimId}/agent/conversation";
        if (claimId === undefined || claimId === null)
            throw new globalThis.Error("The parameter 'claimId' must be defined.");
        url_ = url_.replace("{claimId}", encodeURIComponent("" + claimId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearClaimAgentConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearClaimAgentConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearClaimAgentConversation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a temporary file for a claim agent run
     * @param conversationId (optional) 
     * @param file (optional) 
     * @return Created
     */
    uploadClaimAgentTemporaryFile(claimId: number, conversationId?: string | null | undefined, file?: FileParameter | undefined, httpContext?: HttpContext): Observable<ClaimAgentTemporaryUploadResponse> {
        let url_ = this.baseUrl + "/api/agent/claims/{claimId}/agent/uploads?";
        if (claimId === undefined || claimId === null)
            throw new globalThis.Error("The parameter 'claimId' must be defined.");
        url_ = url_.replace("{claimId}", encodeURIComponent("" + claimId));
        if (conversationId !== undefined && conversationId !== null)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadClaimAgentTemporaryFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadClaimAgentTemporaryFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimAgentTemporaryUploadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimAgentTemporaryUploadResponse>;
        }));
    }

    protected processUploadClaimAgentTemporaryFile(response: HttpResponseBase): Observable<ClaimAgentTemporaryUploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ClaimAgentTemporaryUploadResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Plan or publish bounded CRM snapshot events to repair missed AgentMosaic Queue deliveries
     * @param body (optional) 
     * @return OK
     */
    reconcileAgentMosaicCrmEvents(body?: CrmEventReconciliationRequest | undefined, httpContext?: HttpContext): Observable<CrmEventReconciliationResult> {
        let url_ = this.baseUrl + "/api/agent-mosaic/event-recovery/crm-reconciliation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReconcileAgentMosaicCrmEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReconcileAgentMosaicCrmEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CrmEventReconciliationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CrmEventReconciliationResult>;
        }));
    }

    protected processReconcileAgentMosaicCrmEvents(response: HttpResponseBase): Observable<CrmEventReconciliationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrmEventReconciliationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AgentActivityFeedDto implements IAgentActivityFeedDto {
    entityType?: string;
    entityId?: number;
    total?: number;
    groups?: AgentActivityFeedGroupDto[];

    [key: string]: any;

    constructor(data?: IAgentActivityFeedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : null as any;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : null as any;
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(AgentActivityFeedGroupDto.fromJS(item));
            }
            else {
                this.groups = null as any;
            }
        }
    }

    static fromJS(data: any): AgentActivityFeedDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentActivityFeedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["entityType"] = this.entityType !== undefined ? this.entityType : null as any;
        data["entityId"] = this.entityId !== undefined ? this.entityId : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentActivityFeedDto {
    entityType?: string;
    entityId?: number;
    total?: number;
    groups?: AgentActivityFeedGroupDto[];

    [key: string]: any;
}

export class AgentActivityFeedGroupDto implements IAgentActivityFeedGroupDto {
    label?: string;
    items?: AgentActivityFeedItemDto[];

    [key: string]: any;

    constructor(data?: IAgentActivityFeedGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgentActivityFeedItemDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): AgentActivityFeedGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentActivityFeedGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["label"] = this.label !== undefined ? this.label : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentActivityFeedGroupDto {
    label?: string;
    items?: AgentActivityFeedItemDto[];

    [key: string]: any;
}

export class AgentActivityFeedItemDto implements IAgentActivityFeedItemDto {
    id?: number;
    claimId?: number;
    activityType?: string;
    activityTypeLabel?: string;
    iconKey?: string;
    displayName?: string;
    createdWhen?: string;
    details?: string;
    isQuillData?: boolean | null;
    isPinned?: boolean | null;
    confidential?: boolean | null;
    billable?: boolean | null;
    contactId?: number | null;
    contactName?: string;
    assignmentId?: number | null;
    assignmentCompleted?: boolean | null;
    emailSubject?: string;
    emailFrom?: string;
    emailTo?: string;
    attachmentFileName?: string;
    attachmentContentType?: string;
    attachmentContainer?: string;
    attachmentReferenceId?: string;
    mentions?: AgentMentionReferenceDto[];

    [key: string]: any;

    constructor(data?: IAgentActivityFeedItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : null as any;
            this.activityTypeLabel = _data["activityTypeLabel"] !== undefined ? _data["activityTypeLabel"] : null as any;
            this.iconKey = _data["iconKey"] !== undefined ? _data["iconKey"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.createdWhen = _data["createdWhen"] !== undefined ? _data["createdWhen"] : null as any;
            this.details = _data["details"] !== undefined ? _data["details"] : null as any;
            this.isQuillData = _data["isQuillData"] !== undefined ? _data["isQuillData"] : null as any;
            this.isPinned = _data["isPinned"] !== undefined ? _data["isPinned"] : null as any;
            this.confidential = _data["confidential"] !== undefined ? _data["confidential"] : null as any;
            this.billable = _data["billable"] !== undefined ? _data["billable"] : null as any;
            this.contactId = _data["contactId"] !== undefined ? _data["contactId"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.assignmentId = _data["assignmentId"] !== undefined ? _data["assignmentId"] : null as any;
            this.assignmentCompleted = _data["assignmentCompleted"] !== undefined ? _data["assignmentCompleted"] : null as any;
            this.emailSubject = _data["emailSubject"] !== undefined ? _data["emailSubject"] : null as any;
            this.emailFrom = _data["emailFrom"] !== undefined ? _data["emailFrom"] : null as any;
            this.emailTo = _data["emailTo"] !== undefined ? _data["emailTo"] : null as any;
            this.attachmentFileName = _data["attachmentFileName"] !== undefined ? _data["attachmentFileName"] : null as any;
            this.attachmentContentType = _data["attachmentContentType"] !== undefined ? _data["attachmentContentType"] : null as any;
            this.attachmentContainer = _data["attachmentContainer"] !== undefined ? _data["attachmentContainer"] : null as any;
            this.attachmentReferenceId = _data["attachmentReferenceId"] !== undefined ? _data["attachmentReferenceId"] : null as any;
            if (Array.isArray(_data["mentions"])) {
                this.mentions = [] as any;
                for (let item of _data["mentions"])
                    this.mentions!.push(AgentMentionReferenceDto.fromJS(item));
            }
            else {
                this.mentions = null as any;
            }
        }
    }

    static fromJS(data: any): AgentActivityFeedItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentActivityFeedItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["activityType"] = this.activityType !== undefined ? this.activityType : null as any;
        data["activityTypeLabel"] = this.activityTypeLabel !== undefined ? this.activityTypeLabel : null as any;
        data["iconKey"] = this.iconKey !== undefined ? this.iconKey : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["createdWhen"] = this.createdWhen !== undefined ? this.createdWhen : null as any;
        data["details"] = this.details !== undefined ? this.details : null as any;
        data["isQuillData"] = this.isQuillData !== undefined ? this.isQuillData : null as any;
        data["isPinned"] = this.isPinned !== undefined ? this.isPinned : null as any;
        data["confidential"] = this.confidential !== undefined ? this.confidential : null as any;
        data["billable"] = this.billable !== undefined ? this.billable : null as any;
        data["contactId"] = this.contactId !== undefined ? this.contactId : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["assignmentId"] = this.assignmentId !== undefined ? this.assignmentId : null as any;
        data["assignmentCompleted"] = this.assignmentCompleted !== undefined ? this.assignmentCompleted : null as any;
        data["emailSubject"] = this.emailSubject !== undefined ? this.emailSubject : null as any;
        data["emailFrom"] = this.emailFrom !== undefined ? this.emailFrom : null as any;
        data["emailTo"] = this.emailTo !== undefined ? this.emailTo : null as any;
        data["attachmentFileName"] = this.attachmentFileName !== undefined ? this.attachmentFileName : null as any;
        data["attachmentContentType"] = this.attachmentContentType !== undefined ? this.attachmentContentType : null as any;
        data["attachmentContainer"] = this.attachmentContainer !== undefined ? this.attachmentContainer : null as any;
        data["attachmentReferenceId"] = this.attachmentReferenceId !== undefined ? this.attachmentReferenceId : null as any;
        if (Array.isArray(this.mentions)) {
            data["mentions"] = [];
            for (let item of this.mentions)
                data["mentions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentActivityFeedItemDto {
    id?: number;
    claimId?: number;
    activityType?: string;
    activityTypeLabel?: string;
    iconKey?: string;
    displayName?: string;
    createdWhen?: string;
    details?: string;
    isQuillData?: boolean | null;
    isPinned?: boolean | null;
    confidential?: boolean | null;
    billable?: boolean | null;
    contactId?: number | null;
    contactName?: string;
    assignmentId?: number | null;
    assignmentCompleted?: boolean | null;
    emailSubject?: string;
    emailFrom?: string;
    emailTo?: string;
    attachmentFileName?: string;
    attachmentContentType?: string;
    attachmentContainer?: string;
    attachmentReferenceId?: string;
    mentions?: AgentMentionReferenceDto[];

    [key: string]: any;
}

export class AgentClaimAccountingLineItemDto implements IAgentClaimAccountingLineItemDto {
    id?: number;
    date?: DateTime | null;
    amount?: number;
    typeName?: string;
    shortDescription?: string | null;

    [key: string]: any;

    constructor(data?: IAgentClaimAccountingLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : null as any;
            this.shortDescription = _data["shortDescription"] !== undefined ? _data["shortDescription"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimAccountingLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimAccountingLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date ? this.date.toString() : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["typeName"] = this.typeName !== undefined ? this.typeName : null as any;
        data["shortDescription"] = this.shortDescription !== undefined ? this.shortDescription : null as any;
        return data;
    }
}

export interface IAgentClaimAccountingLineItemDto {
    id?: number;
    date?: DateTime | null;
    amount?: number;
    typeName?: string;
    shortDescription?: string | null;

    [key: string]: any;
}

export class AgentClaimAccountingSummaryDto implements IAgentClaimAccountingSummaryDto {
    companyFee?: number | null;
    feeType?: number | null;
    totalPayments?: number;
    paymentCount?: number;
    payments?: AgentClaimAccountingLineItemDto[];
    totalSettlements?: number;
    settlementCount?: number;
    settlements?: AgentClaimAccountingLineItemDto[];
    totalExpenses?: number;
    expenseCount?: number;
    expenses?: AgentClaimAccountingLineItemDto[];
    totalCompanyExpenses?: number;
    totalBillableClientExpenses?: number;
    totalCommissions?: number;
    commissionCount?: number;
    commissions?: AgentClaimAccountingLineItemDto[];
    totalTime?: ClaimTimeLoggedDto;
    totalBillableTime?: ClaimTimeLoggedDto;

    [key: string]: any;

    constructor(data?: IAgentClaimAccountingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.companyFee = _data["companyFee"] !== undefined ? _data["companyFee"] : null as any;
            this.feeType = _data["feeType"] !== undefined ? _data["feeType"] : null as any;
            this.totalPayments = _data["totalPayments"] !== undefined ? _data["totalPayments"] : null as any;
            this.paymentCount = _data["paymentCount"] !== undefined ? _data["paymentCount"] : null as any;
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(AgentClaimAccountingLineItemDto.fromJS(item));
            }
            else {
                this.payments = null as any;
            }
            this.totalSettlements = _data["totalSettlements"] !== undefined ? _data["totalSettlements"] : null as any;
            this.settlementCount = _data["settlementCount"] !== undefined ? _data["settlementCount"] : null as any;
            if (Array.isArray(_data["settlements"])) {
                this.settlements = [] as any;
                for (let item of _data["settlements"])
                    this.settlements!.push(AgentClaimAccountingLineItemDto.fromJS(item));
            }
            else {
                this.settlements = null as any;
            }
            this.totalExpenses = _data["totalExpenses"] !== undefined ? _data["totalExpenses"] : null as any;
            this.expenseCount = _data["expenseCount"] !== undefined ? _data["expenseCount"] : null as any;
            if (Array.isArray(_data["expenses"])) {
                this.expenses = [] as any;
                for (let item of _data["expenses"])
                    this.expenses!.push(AgentClaimAccountingLineItemDto.fromJS(item));
            }
            else {
                this.expenses = null as any;
            }
            this.totalCompanyExpenses = _data["totalCompanyExpenses"] !== undefined ? _data["totalCompanyExpenses"] : null as any;
            this.totalBillableClientExpenses = _data["totalBillableClientExpenses"] !== undefined ? _data["totalBillableClientExpenses"] : null as any;
            this.totalCommissions = _data["totalCommissions"] !== undefined ? _data["totalCommissions"] : null as any;
            this.commissionCount = _data["commissionCount"] !== undefined ? _data["commissionCount"] : null as any;
            if (Array.isArray(_data["commissions"])) {
                this.commissions = [] as any;
                for (let item of _data["commissions"])
                    this.commissions!.push(AgentClaimAccountingLineItemDto.fromJS(item));
            }
            else {
                this.commissions = null as any;
            }
            this.totalTime = _data["totalTime"] ? ClaimTimeLoggedDto.fromJS(_data["totalTime"]) : null as any;
            this.totalBillableTime = _data["totalBillableTime"] ? ClaimTimeLoggedDto.fromJS(_data["totalBillableTime"]) : null as any;
        }
    }

    static fromJS(data: any): AgentClaimAccountingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimAccountingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["companyFee"] = this.companyFee !== undefined ? this.companyFee : null as any;
        data["feeType"] = this.feeType !== undefined ? this.feeType : null as any;
        data["totalPayments"] = this.totalPayments !== undefined ? this.totalPayments : null as any;
        data["paymentCount"] = this.paymentCount !== undefined ? this.paymentCount : null as any;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item ? item.toJSON() : null as any);
        }
        data["totalSettlements"] = this.totalSettlements !== undefined ? this.totalSettlements : null as any;
        data["settlementCount"] = this.settlementCount !== undefined ? this.settlementCount : null as any;
        if (Array.isArray(this.settlements)) {
            data["settlements"] = [];
            for (let item of this.settlements)
                data["settlements"].push(item ? item.toJSON() : null as any);
        }
        data["totalExpenses"] = this.totalExpenses !== undefined ? this.totalExpenses : null as any;
        data["expenseCount"] = this.expenseCount !== undefined ? this.expenseCount : null as any;
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item ? item.toJSON() : null as any);
        }
        data["totalCompanyExpenses"] = this.totalCompanyExpenses !== undefined ? this.totalCompanyExpenses : null as any;
        data["totalBillableClientExpenses"] = this.totalBillableClientExpenses !== undefined ? this.totalBillableClientExpenses : null as any;
        data["totalCommissions"] = this.totalCommissions !== undefined ? this.totalCommissions : null as any;
        data["commissionCount"] = this.commissionCount !== undefined ? this.commissionCount : null as any;
        if (Array.isArray(this.commissions)) {
            data["commissions"] = [];
            for (let item of this.commissions)
                data["commissions"].push(item ? item.toJSON() : null as any);
        }
        data["totalTime"] = this.totalTime ? this.totalTime.toJSON() : null as any;
        data["totalBillableTime"] = this.totalBillableTime ? this.totalBillableTime.toJSON() : null as any;
        return data;
    }
}

export interface IAgentClaimAccountingSummaryDto {
    companyFee?: number | null;
    feeType?: number | null;
    totalPayments?: number;
    paymentCount?: number;
    payments?: AgentClaimAccountingLineItemDto[];
    totalSettlements?: number;
    settlementCount?: number;
    settlements?: AgentClaimAccountingLineItemDto[];
    totalExpenses?: number;
    expenseCount?: number;
    expenses?: AgentClaimAccountingLineItemDto[];
    totalCompanyExpenses?: number;
    totalBillableClientExpenses?: number;
    totalCommissions?: number;
    commissionCount?: number;
    commissions?: AgentClaimAccountingLineItemDto[];
    totalTime?: ClaimTimeLoggedDto;
    totalBillableTime?: ClaimTimeLoggedDto;

    [key: string]: any;
}

export class AgentClaimCompanyContactDto implements IAgentClaimCompanyContactDto {
    id?: number | null;
    companyName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    city?: string | null;
    state?: string | null;

    [key: string]: any;

    constructor(data?: IAgentClaimCompanyContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimCompanyContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimCompanyContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IAgentClaimCompanyContactDto {
    id?: number | null;
    companyName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    city?: string | null;
    state?: string | null;

    [key: string]: any;
}

export class AgentClaimCompanyNameDto implements IAgentClaimCompanyNameDto {
    id?: number | null;
    companyName?: string | null;

    [key: string]: any;

    constructor(data?: IAgentClaimCompanyNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimCompanyNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimCompanyNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        return data;
    }
}

export interface IAgentClaimCompanyNameDto {
    id?: number | null;
    companyName?: string | null;

    [key: string]: any;
}

export class AgentClaimContactDetailsPayload implements IAgentClaimContactDetailsPayload {
    firstName?: string;
    lastName?: string;
    email?: string | null;
    phoneNumber?: string | null;
    street1?: string | null;
    street2?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;

    [key: string]: any;

    constructor(data?: IAgentClaimContactDetailsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.street1 = _data["street1"] !== undefined ? _data["street1"] : null as any;
            this.street2 = _data["street2"] !== undefined ? _data["street2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimContactDetailsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimContactDetailsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["street1"] = this.street1 !== undefined ? this.street1 : null as any;
        data["street2"] = this.street2 !== undefined ? this.street2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        return data;
    }
}

export interface IAgentClaimContactDetailsPayload {
    firstName?: string;
    lastName?: string;
    email?: string | null;
    phoneNumber?: string | null;
    street1?: string | null;
    street2?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;

    [key: string]: any;
}

export class AgentClaimContextDto implements IAgentClaimContextDto {
    claimId?: number;
    overview?: AgentClaimDto | null;
    insurance?: AgentClaimInsuranceContextDto | null;
    contacts?: ClaimContactCardDto[] | null;
    totalContactCount?: number | null;
    financialTotals?: AgentClaimFinancialTotalsDto | null;
    tasksRollup?: AgentClaimTasksRollupDto | null;
    recentActivity?: AgentActivityFeedItemDto[] | null;
    filesRollup?: AgentClaimFilesRollupDto | null;
    omittedSections?: { [key: string]: string; };

    [key: string]: any;

    constructor(data?: IAgentClaimContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.overview = _data["overview"] ? AgentClaimDto.fromJS(_data["overview"]) : null as any;
            this.insurance = _data["insurance"] ? AgentClaimInsuranceContextDto.fromJS(_data["insurance"]) : null as any;
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ClaimContactCardDto.fromJS(item));
            }
            else {
                this.contacts = null as any;
            }
            this.totalContactCount = _data["totalContactCount"] !== undefined ? _data["totalContactCount"] : null as any;
            this.financialTotals = _data["financialTotals"] ? AgentClaimFinancialTotalsDto.fromJS(_data["financialTotals"]) : null as any;
            this.tasksRollup = _data["tasksRollup"] ? AgentClaimTasksRollupDto.fromJS(_data["tasksRollup"]) : null as any;
            if (Array.isArray(_data["recentActivity"])) {
                this.recentActivity = [] as any;
                for (let item of _data["recentActivity"])
                    this.recentActivity!.push(AgentActivityFeedItemDto.fromJS(item));
            }
            else {
                this.recentActivity = null as any;
            }
            this.filesRollup = _data["filesRollup"] ? AgentClaimFilesRollupDto.fromJS(_data["filesRollup"]) : null as any;
            if (_data["omittedSections"]) {
                this.omittedSections = {} as any;
                for (let key in _data["omittedSections"]) {
                    if (_data["omittedSections"].hasOwnProperty(key))
                        (this.omittedSections as any)![key] = _data["omittedSections"][key] !== undefined ? _data["omittedSections"][key] : null as any;
                }
            }
            else {
                this.omittedSections = null as any;
            }
        }
    }

    static fromJS(data: any): AgentClaimContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["overview"] = this.overview ? this.overview.toJSON() : null as any;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : null as any;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : null as any);
        }
        data["totalContactCount"] = this.totalContactCount !== undefined ? this.totalContactCount : null as any;
        data["financialTotals"] = this.financialTotals ? this.financialTotals.toJSON() : null as any;
        data["tasksRollup"] = this.tasksRollup ? this.tasksRollup.toJSON() : null as any;
        if (Array.isArray(this.recentActivity)) {
            data["recentActivity"] = [];
            for (let item of this.recentActivity)
                data["recentActivity"].push(item ? item.toJSON() : null as any);
        }
        data["filesRollup"] = this.filesRollup ? this.filesRollup.toJSON() : null as any;
        if (this.omittedSections) {
            data["omittedSections"] = {};
            for (let key in this.omittedSections) {
                if (this.omittedSections.hasOwnProperty(key))
                    (data["omittedSections"] as any)[key] = this.omittedSections[key] !== undefined ? this.omittedSections[key] : null as any;
            }
        }
        return data;
    }
}

export interface IAgentClaimContextDto {
    claimId?: number;
    overview?: AgentClaimDto | null;
    insurance?: AgentClaimInsuranceContextDto | null;
    contacts?: ClaimContactCardDto[] | null;
    totalContactCount?: number | null;
    financialTotals?: AgentClaimFinancialTotalsDto | null;
    tasksRollup?: AgentClaimTasksRollupDto | null;
    recentActivity?: AgentActivityFeedItemDto[] | null;
    filesRollup?: AgentClaimFilesRollupDto | null;
    omittedSections?: { [key: string]: string; };

    [key: string]: any;
}

export class AgentClaimDocumentSearchRequest implements IAgentClaimDocumentSearchRequest {
    query?: string;
    maxResults?: number | null;

    [key: string]: any;

    constructor(data?: IAgentClaimDocumentSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.query = _data["query"] !== undefined ? _data["query"] : null as any;
            this.maxResults = _data["maxResults"] !== undefined ? _data["maxResults"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimDocumentSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimDocumentSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["query"] = this.query !== undefined ? this.query : null as any;
        data["maxResults"] = this.maxResults !== undefined ? this.maxResults : null as any;
        return data;
    }
}

export interface IAgentClaimDocumentSearchRequest {
    query?: string;
    maxResults?: number | null;

    [key: string]: any;
}

export class AgentClaimDocumentSearchResponse implements IAgentClaimDocumentSearchResponse {
    claimId?: number;
    query?: string;
    totalMatches?: number;
    truncated?: boolean;
    results?: AgentClaimDocumentSearchResultDto[];

    [key: string]: any;

    constructor(data?: IAgentClaimDocumentSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.query = _data["query"] !== undefined ? _data["query"] : null as any;
            this.totalMatches = _data["totalMatches"] !== undefined ? _data["totalMatches"] : null as any;
            this.truncated = _data["truncated"] !== undefined ? _data["truncated"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AgentClaimDocumentSearchResultDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): AgentClaimDocumentSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimDocumentSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["query"] = this.query !== undefined ? this.query : null as any;
        data["totalMatches"] = this.totalMatches !== undefined ? this.totalMatches : null as any;
        data["truncated"] = this.truncated !== undefined ? this.truncated : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentClaimDocumentSearchResponse {
    claimId?: number;
    query?: string;
    totalMatches?: number;
    truncated?: boolean;
    results?: AgentClaimDocumentSearchResultDto[];

    [key: string]: any;
}

export class AgentClaimDocumentSearchResultDto implements IAgentClaimDocumentSearchResultDto {
    attachmentId?: number;
    fileName?: string;
    folderName?: string | null;
    matchedIn?: string;
    snippet?: string | null;
    extractedTextAvailable?: boolean;

    [key: string]: any;

    constructor(data?: IAgentClaimDocumentSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.attachmentId = _data["attachmentId"] !== undefined ? _data["attachmentId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.folderName = _data["folderName"] !== undefined ? _data["folderName"] : null as any;
            this.matchedIn = _data["matchedIn"] !== undefined ? _data["matchedIn"] : null as any;
            this.snippet = _data["snippet"] !== undefined ? _data["snippet"] : null as any;
            this.extractedTextAvailable = _data["extractedTextAvailable"] !== undefined ? _data["extractedTextAvailable"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimDocumentSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimDocumentSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["folderName"] = this.folderName !== undefined ? this.folderName : null as any;
        data["matchedIn"] = this.matchedIn !== undefined ? this.matchedIn : null as any;
        data["snippet"] = this.snippet !== undefined ? this.snippet : null as any;
        data["extractedTextAvailable"] = this.extractedTextAvailable !== undefined ? this.extractedTextAvailable : null as any;
        return data;
    }
}

export interface IAgentClaimDocumentSearchResultDto {
    attachmentId?: number;
    fileName?: string;
    folderName?: string | null;
    matchedIn?: string;
    snippet?: string | null;
    extractedTextAvailable?: boolean;

    [key: string]: any;
}

export class AgentClaimDocumentTextDto implements IAgentClaimDocumentTextDto {
    attachmentId?: number;
    fileName?: string;
    status?: string;
    extractedText?: string | null;
    truncated?: boolean;
    extractionSource?: string | null;
    extractedWhen?: DateTime | null;

    [key: string]: any;

    constructor(data?: IAgentClaimDocumentTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.attachmentId = _data["attachmentId"] !== undefined ? _data["attachmentId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.extractedText = _data["extractedText"] !== undefined ? _data["extractedText"] : null as any;
            this.truncated = _data["truncated"] !== undefined ? _data["truncated"] : null as any;
            this.extractionSource = _data["extractionSource"] !== undefined ? _data["extractionSource"] : null as any;
            this.extractedWhen = _data["extractedWhen"] ? DateTime.fromISO(_data["extractedWhen"].toString()) : null as any;
        }
    }

    static fromJS(data: any): AgentClaimDocumentTextDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimDocumentTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["extractedText"] = this.extractedText !== undefined ? this.extractedText : null as any;
        data["truncated"] = this.truncated !== undefined ? this.truncated : null as any;
        data["extractionSource"] = this.extractionSource !== undefined ? this.extractionSource : null as any;
        data["extractedWhen"] = this.extractedWhen ? this.extractedWhen.toString() : null as any;
        return data;
    }
}

export interface IAgentClaimDocumentTextDto {
    attachmentId?: number;
    fileName?: string;
    status?: string;
    extractedText?: string | null;
    truncated?: boolean;
    extractionSource?: string | null;
    extractedWhen?: DateTime | null;

    [key: string]: any;
}

export class AgentClaimDto implements IAgentClaimDto {
    id?: number;
    claimNumber?: string;
    shortId?: string | null;
    lossDescription?: string | null;
    dateOfLoss?: DateTime | null;
    lossType?: number | null;
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    claimStatusName?: string | null;
    claimStatusId?: number | null;
    claimStatusColor?: string | null;
    claimStatusTextColor?: string | null;
    policyNo?: string | null;
    policyholder?: AgentContactDto;
    policyTypeId?: number | null;
    policyTypeName?: string | null;
    policyFormId?: number | null;
    policyFormName?: string | null;
    startDate?: DateTime | null;
    expirationDate?: DateTime | null;
    deductible?: number | null;
    totalAmountOfPolicy?: number | null;
    dwellingCoverageA?: number | null;
    otherStructuresB?: number | null;
    personalPropertyContentsC?: number | null;
    lossOfUseRentD?: number | null;
    insuranceCompany?: AgentClaimCompanyContactDto | null;
    mortgageCompany?: AgentClaimCompanyNameDto | null;
    secondaryMortgageCompany?: AgentClaimCompanyNameDto | null;
    openTaskCount?: number | null;
    overdueTaskCount?: number | null;
    lastActivityAt?: DateTime | null;

    [key: string]: any;

    constructor(data?: IAgentClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.claimNumber = _data["claimNumber"] !== undefined ? _data["claimNumber"] : null as any;
            this.shortId = _data["shortId"] !== undefined ? _data["shortId"] : null as any;
            this.lossDescription = _data["lossDescription"] !== undefined ? _data["lossDescription"] : null as any;
            this.dateOfLoss = _data["dateOfLoss"] ? DateTime.fromISO(_data["dateOfLoss"].toString()) : null as any;
            this.lossType = _data["lossType"] !== undefined ? _data["lossType"] : null as any;
            this.street1 = _data["street1"] !== undefined ? _data["street1"] : null as any;
            this.street2 = _data["street2"] !== undefined ? _data["street2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.claimStatusName = _data["claimStatusName"] !== undefined ? _data["claimStatusName"] : null as any;
            this.claimStatusId = _data["claimStatusId"] !== undefined ? _data["claimStatusId"] : null as any;
            this.claimStatusColor = _data["claimStatusColor"] !== undefined ? _data["claimStatusColor"] : null as any;
            this.claimStatusTextColor = _data["claimStatusTextColor"] !== undefined ? _data["claimStatusTextColor"] : null as any;
            this.policyNo = _data["policyNo"] !== undefined ? _data["policyNo"] : null as any;
            this.policyholder = _data["policyholder"] ? AgentContactDto.fromJS(_data["policyholder"]) : null as any;
            this.policyTypeId = _data["policyTypeId"] !== undefined ? _data["policyTypeId"] : null as any;
            this.policyTypeName = _data["policyTypeName"] !== undefined ? _data["policyTypeName"] : null as any;
            this.policyFormId = _data["policyFormId"] !== undefined ? _data["policyFormId"] : null as any;
            this.policyFormName = _data["policyFormName"] !== undefined ? _data["policyFormName"] : null as any;
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : null as any;
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : null as any;
            this.deductible = _data["deductible"] !== undefined ? _data["deductible"] : null as any;
            this.totalAmountOfPolicy = _data["totalAmountOfPolicy"] !== undefined ? _data["totalAmountOfPolicy"] : null as any;
            this.dwellingCoverageA = _data["dwellingCoverageA"] !== undefined ? _data["dwellingCoverageA"] : null as any;
            this.otherStructuresB = _data["otherStructuresB"] !== undefined ? _data["otherStructuresB"] : null as any;
            this.personalPropertyContentsC = _data["personalPropertyContentsC"] !== undefined ? _data["personalPropertyContentsC"] : null as any;
            this.lossOfUseRentD = _data["lossOfUseRentD"] !== undefined ? _data["lossOfUseRentD"] : null as any;
            this.insuranceCompany = _data["insuranceCompany"] ? AgentClaimCompanyContactDto.fromJS(_data["insuranceCompany"]) : null as any;
            this.mortgageCompany = _data["mortgageCompany"] ? AgentClaimCompanyNameDto.fromJS(_data["mortgageCompany"]) : null as any;
            this.secondaryMortgageCompany = _data["secondaryMortgageCompany"] ? AgentClaimCompanyNameDto.fromJS(_data["secondaryMortgageCompany"]) : null as any;
            this.openTaskCount = _data["openTaskCount"] !== undefined ? _data["openTaskCount"] : null as any;
            this.overdueTaskCount = _data["overdueTaskCount"] !== undefined ? _data["overdueTaskCount"] : null as any;
            this.lastActivityAt = _data["lastActivityAt"] ? DateTime.fromISO(_data["lastActivityAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): AgentClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["claimNumber"] = this.claimNumber !== undefined ? this.claimNumber : null as any;
        data["shortId"] = this.shortId !== undefined ? this.shortId : null as any;
        data["lossDescription"] = this.lossDescription !== undefined ? this.lossDescription : null as any;
        data["dateOfLoss"] = this.dateOfLoss ? this.dateOfLoss.toString() : null as any;
        data["lossType"] = this.lossType !== undefined ? this.lossType : null as any;
        data["street1"] = this.street1 !== undefined ? this.street1 : null as any;
        data["street2"] = this.street2 !== undefined ? this.street2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["claimStatusName"] = this.claimStatusName !== undefined ? this.claimStatusName : null as any;
        data["claimStatusId"] = this.claimStatusId !== undefined ? this.claimStatusId : null as any;
        data["claimStatusColor"] = this.claimStatusColor !== undefined ? this.claimStatusColor : null as any;
        data["claimStatusTextColor"] = this.claimStatusTextColor !== undefined ? this.claimStatusTextColor : null as any;
        data["policyNo"] = this.policyNo !== undefined ? this.policyNo : null as any;
        data["policyholder"] = this.policyholder ? this.policyholder.toJSON() : null as any;
        data["policyTypeId"] = this.policyTypeId !== undefined ? this.policyTypeId : null as any;
        data["policyTypeName"] = this.policyTypeName !== undefined ? this.policyTypeName : null as any;
        data["policyFormId"] = this.policyFormId !== undefined ? this.policyFormId : null as any;
        data["policyFormName"] = this.policyFormName !== undefined ? this.policyFormName : null as any;
        data["startDate"] = this.startDate ? this.startDate.toString() : null as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : null as any;
        data["deductible"] = this.deductible !== undefined ? this.deductible : null as any;
        data["totalAmountOfPolicy"] = this.totalAmountOfPolicy !== undefined ? this.totalAmountOfPolicy : null as any;
        data["dwellingCoverageA"] = this.dwellingCoverageA !== undefined ? this.dwellingCoverageA : null as any;
        data["otherStructuresB"] = this.otherStructuresB !== undefined ? this.otherStructuresB : null as any;
        data["personalPropertyContentsC"] = this.personalPropertyContentsC !== undefined ? this.personalPropertyContentsC : null as any;
        data["lossOfUseRentD"] = this.lossOfUseRentD !== undefined ? this.lossOfUseRentD : null as any;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : null as any;
        data["mortgageCompany"] = this.mortgageCompany ? this.mortgageCompany.toJSON() : null as any;
        data["secondaryMortgageCompany"] = this.secondaryMortgageCompany ? this.secondaryMortgageCompany.toJSON() : null as any;
        data["openTaskCount"] = this.openTaskCount !== undefined ? this.openTaskCount : null as any;
        data["overdueTaskCount"] = this.overdueTaskCount !== undefined ? this.overdueTaskCount : null as any;
        data["lastActivityAt"] = this.lastActivityAt ? this.lastActivityAt.toString() : null as any;
        return data;
    }
}

export interface IAgentClaimDto {
    id?: number;
    claimNumber?: string;
    shortId?: string | null;
    lossDescription?: string | null;
    dateOfLoss?: DateTime | null;
    lossType?: number | null;
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    claimStatusName?: string | null;
    claimStatusId?: number | null;
    claimStatusColor?: string | null;
    claimStatusTextColor?: string | null;
    policyNo?: string | null;
    policyholder?: AgentContactDto;
    policyTypeId?: number | null;
    policyTypeName?: string | null;
    policyFormId?: number | null;
    policyFormName?: string | null;
    startDate?: DateTime | null;
    expirationDate?: DateTime | null;
    deductible?: number | null;
    totalAmountOfPolicy?: number | null;
    dwellingCoverageA?: number | null;
    otherStructuresB?: number | null;
    personalPropertyContentsC?: number | null;
    lossOfUseRentD?: number | null;
    insuranceCompany?: AgentClaimCompanyContactDto | null;
    mortgageCompany?: AgentClaimCompanyNameDto | null;
    secondaryMortgageCompany?: AgentClaimCompanyNameDto | null;
    openTaskCount?: number | null;
    overdueTaskCount?: number | null;
    lastActivityAt?: DateTime | null;

    [key: string]: any;
}

export class AgentClaimFieldOptionGroupDto implements IAgentClaimFieldOptionGroupDto {
    column?: string;
    label?: string;
    options?: SelectOptionDto[];

    [key: string]: any;

    constructor(data?: IAgentClaimFieldOptionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.column = _data["column"] !== undefined ? _data["column"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SelectOptionDto.fromJS(item));
            }
            else {
                this.options = null as any;
            }
        }
    }

    static fromJS(data: any): AgentClaimFieldOptionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimFieldOptionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["column"] = this.column !== undefined ? this.column : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentClaimFieldOptionGroupDto {
    column?: string;
    label?: string;
    options?: SelectOptionDto[];

    [key: string]: any;
}

export class AgentClaimFieldOptionsDto implements IAgentClaimFieldOptionsDto {
    fields?: AgentClaimFieldOptionGroupDto[];

    [key: string]: any;

    constructor(data?: IAgentClaimFieldOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(AgentClaimFieldOptionGroupDto.fromJS(item));
            }
            else {
                this.fields = null as any;
            }
        }
    }

    static fromJS(data: any): AgentClaimFieldOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimFieldOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentClaimFieldOptionsDto {
    fields?: AgentClaimFieldOptionGroupDto[];

    [key: string]: any;
}

export class AgentClaimFilesRollupDto implements IAgentClaimFilesRollupDto {
    totalFiles?: number;
    folders?: AgentClaimFolderRollupDto[];

    [key: string]: any;

    constructor(data?: IAgentClaimFilesRollupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalFiles = _data["totalFiles"] !== undefined ? _data["totalFiles"] : null as any;
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders!.push(AgentClaimFolderRollupDto.fromJS(item));
            }
            else {
                this.folders = null as any;
            }
        }
    }

    static fromJS(data: any): AgentClaimFilesRollupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimFilesRollupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalFiles"] = this.totalFiles !== undefined ? this.totalFiles : null as any;
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentClaimFilesRollupDto {
    totalFiles?: number;
    folders?: AgentClaimFolderRollupDto[];

    [key: string]: any;
}

export class AgentClaimFinancialTotalsDto implements IAgentClaimFinancialTotalsDto {
    totalPayments?: number;
    totalSettlements?: number;
    totalExpenses?: number;
    totalCommissions?: number;
    companyFee?: number | null;
    estimatedClaimValue?: number | null;
    deductible?: number | null;

    [key: string]: any;

    constructor(data?: IAgentClaimFinancialTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalPayments = _data["totalPayments"] !== undefined ? _data["totalPayments"] : null as any;
            this.totalSettlements = _data["totalSettlements"] !== undefined ? _data["totalSettlements"] : null as any;
            this.totalExpenses = _data["totalExpenses"] !== undefined ? _data["totalExpenses"] : null as any;
            this.totalCommissions = _data["totalCommissions"] !== undefined ? _data["totalCommissions"] : null as any;
            this.companyFee = _data["companyFee"] !== undefined ? _data["companyFee"] : null as any;
            this.estimatedClaimValue = _data["estimatedClaimValue"] !== undefined ? _data["estimatedClaimValue"] : null as any;
            this.deductible = _data["deductible"] !== undefined ? _data["deductible"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimFinancialTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimFinancialTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalPayments"] = this.totalPayments !== undefined ? this.totalPayments : null as any;
        data["totalSettlements"] = this.totalSettlements !== undefined ? this.totalSettlements : null as any;
        data["totalExpenses"] = this.totalExpenses !== undefined ? this.totalExpenses : null as any;
        data["totalCommissions"] = this.totalCommissions !== undefined ? this.totalCommissions : null as any;
        data["companyFee"] = this.companyFee !== undefined ? this.companyFee : null as any;
        data["estimatedClaimValue"] = this.estimatedClaimValue !== undefined ? this.estimatedClaimValue : null as any;
        data["deductible"] = this.deductible !== undefined ? this.deductible : null as any;
        return data;
    }
}

export interface IAgentClaimFinancialTotalsDto {
    totalPayments?: number;
    totalSettlements?: number;
    totalExpenses?: number;
    totalCommissions?: number;
    companyFee?: number | null;
    estimatedClaimValue?: number | null;
    deductible?: number | null;

    [key: string]: any;
}

export class AgentClaimFolderRollupDto implements IAgentClaimFolderRollupDto {
    folderId?: number | null;
    name?: string | null;
    fileCount?: number;

    [key: string]: any;

    constructor(data?: IAgentClaimFolderRollupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.fileCount = _data["fileCount"] !== undefined ? _data["fileCount"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimFolderRollupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimFolderRollupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["folderId"] = this.folderId !== undefined ? this.folderId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["fileCount"] = this.fileCount !== undefined ? this.fileCount : null as any;
        return data;
    }
}

export interface IAgentClaimFolderRollupDto {
    folderId?: number | null;
    name?: string | null;
    fileCount?: number;

    [key: string]: any;
}

export class AgentClaimInsuranceContextDto implements IAgentClaimInsuranceContextDto {
    policyNo?: string | null;
    policyTypeId?: number | null;
    policyTypeName?: string | null;
    policyFormId?: number | null;
    policyFormName?: string | null;
    startDate?: DateTime | null;
    expirationDate?: DateTime | null;
    deductible?: number | null;
    totalAmountOfPolicy?: number | null;
    dwellingCoverageA?: number | null;
    otherStructuresB?: number | null;
    personalPropertyContentsC?: number | null;
    lossOfUseRentD?: number | null;
    insuranceCompany?: AgentClaimCompanyContactDto | null;
    mortgageCompany?: AgentClaimCompanyNameDto | null;
    secondaryMortgageCompany?: AgentClaimCompanyNameDto | null;

    [key: string]: any;

    constructor(data?: IAgentClaimInsuranceContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.policyNo = _data["policyNo"] !== undefined ? _data["policyNo"] : null as any;
            this.policyTypeId = _data["policyTypeId"] !== undefined ? _data["policyTypeId"] : null as any;
            this.policyTypeName = _data["policyTypeName"] !== undefined ? _data["policyTypeName"] : null as any;
            this.policyFormId = _data["policyFormId"] !== undefined ? _data["policyFormId"] : null as any;
            this.policyFormName = _data["policyFormName"] !== undefined ? _data["policyFormName"] : null as any;
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : null as any;
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : null as any;
            this.deductible = _data["deductible"] !== undefined ? _data["deductible"] : null as any;
            this.totalAmountOfPolicy = _data["totalAmountOfPolicy"] !== undefined ? _data["totalAmountOfPolicy"] : null as any;
            this.dwellingCoverageA = _data["dwellingCoverageA"] !== undefined ? _data["dwellingCoverageA"] : null as any;
            this.otherStructuresB = _data["otherStructuresB"] !== undefined ? _data["otherStructuresB"] : null as any;
            this.personalPropertyContentsC = _data["personalPropertyContentsC"] !== undefined ? _data["personalPropertyContentsC"] : null as any;
            this.lossOfUseRentD = _data["lossOfUseRentD"] !== undefined ? _data["lossOfUseRentD"] : null as any;
            this.insuranceCompany = _data["insuranceCompany"] ? AgentClaimCompanyContactDto.fromJS(_data["insuranceCompany"]) : null as any;
            this.mortgageCompany = _data["mortgageCompany"] ? AgentClaimCompanyNameDto.fromJS(_data["mortgageCompany"]) : null as any;
            this.secondaryMortgageCompany = _data["secondaryMortgageCompany"] ? AgentClaimCompanyNameDto.fromJS(_data["secondaryMortgageCompany"]) : null as any;
        }
    }

    static fromJS(data: any): AgentClaimInsuranceContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimInsuranceContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["policyNo"] = this.policyNo !== undefined ? this.policyNo : null as any;
        data["policyTypeId"] = this.policyTypeId !== undefined ? this.policyTypeId : null as any;
        data["policyTypeName"] = this.policyTypeName !== undefined ? this.policyTypeName : null as any;
        data["policyFormId"] = this.policyFormId !== undefined ? this.policyFormId : null as any;
        data["policyFormName"] = this.policyFormName !== undefined ? this.policyFormName : null as any;
        data["startDate"] = this.startDate ? this.startDate.toString() : null as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : null as any;
        data["deductible"] = this.deductible !== undefined ? this.deductible : null as any;
        data["totalAmountOfPolicy"] = this.totalAmountOfPolicy !== undefined ? this.totalAmountOfPolicy : null as any;
        data["dwellingCoverageA"] = this.dwellingCoverageA !== undefined ? this.dwellingCoverageA : null as any;
        data["otherStructuresB"] = this.otherStructuresB !== undefined ? this.otherStructuresB : null as any;
        data["personalPropertyContentsC"] = this.personalPropertyContentsC !== undefined ? this.personalPropertyContentsC : null as any;
        data["lossOfUseRentD"] = this.lossOfUseRentD !== undefined ? this.lossOfUseRentD : null as any;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : null as any;
        data["mortgageCompany"] = this.mortgageCompany ? this.mortgageCompany.toJSON() : null as any;
        data["secondaryMortgageCompany"] = this.secondaryMortgageCompany ? this.secondaryMortgageCompany.toJSON() : null as any;
        return data;
    }
}

export interface IAgentClaimInsuranceContextDto {
    policyNo?: string | null;
    policyTypeId?: number | null;
    policyTypeName?: string | null;
    policyFormId?: number | null;
    policyFormName?: string | null;
    startDate?: DateTime | null;
    expirationDate?: DateTime | null;
    deductible?: number | null;
    totalAmountOfPolicy?: number | null;
    dwellingCoverageA?: number | null;
    otherStructuresB?: number | null;
    personalPropertyContentsC?: number | null;
    lossOfUseRentD?: number | null;
    insuranceCompany?: AgentClaimCompanyContactDto | null;
    mortgageCompany?: AgentClaimCompanyNameDto | null;
    secondaryMortgageCompany?: AgentClaimCompanyNameDto | null;

    [key: string]: any;
}

export class AgentClaimPolicyContextDto implements IAgentClaimPolicyContextDto {
    claimId?: number;
    status?: string;
    policyDocuments?: AgentPolicyDocumentContextDto[];
    totalPolicyDocumentCount?: number;
    truncated?: boolean;

    [key: string]: any;

    constructor(data?: IAgentClaimPolicyContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["policyDocuments"])) {
                this.policyDocuments = [] as any;
                for (let item of _data["policyDocuments"])
                    this.policyDocuments!.push(AgentPolicyDocumentContextDto.fromJS(item));
            }
            else {
                this.policyDocuments = null as any;
            }
            this.totalPolicyDocumentCount = _data["totalPolicyDocumentCount"] !== undefined ? _data["totalPolicyDocumentCount"] : null as any;
            this.truncated = _data["truncated"] !== undefined ? _data["truncated"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimPolicyContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimPolicyContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.policyDocuments)) {
            data["policyDocuments"] = [];
            for (let item of this.policyDocuments)
                data["policyDocuments"].push(item ? item.toJSON() : null as any);
        }
        data["totalPolicyDocumentCount"] = this.totalPolicyDocumentCount !== undefined ? this.totalPolicyDocumentCount : null as any;
        data["truncated"] = this.truncated !== undefined ? this.truncated : null as any;
        return data;
    }
}

export interface IAgentClaimPolicyContextDto {
    claimId?: number;
    status?: string;
    policyDocuments?: AgentPolicyDocumentContextDto[];
    totalPolicyDocumentCount?: number;
    truncated?: boolean;

    [key: string]: any;
}

export class AgentClaimTasksRollupDto implements IAgentClaimTasksRollupDto {
    openCount?: number;
    overdueCount?: number;

    [key: string]: any;

    constructor(data?: IAgentClaimTasksRollupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.openCount = _data["openCount"] !== undefined ? _data["openCount"] : null as any;
            this.overdueCount = _data["overdueCount"] !== undefined ? _data["overdueCount"] : null as any;
        }
    }

    static fromJS(data: any): AgentClaimTasksRollupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentClaimTasksRollupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["openCount"] = this.openCount !== undefined ? this.openCount : null as any;
        data["overdueCount"] = this.overdueCount !== undefined ? this.overdueCount : null as any;
        return data;
    }
}

export interface IAgentClaimTasksRollupDto {
    openCount?: number;
    overdueCount?: number;

    [key: string]: any;
}

export class AgentContactDto implements IAgentContactDto {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    fullName?: string | null;
    address?: string | null;

    [key: string]: any;

    constructor(data?: IAgentContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.street1 = _data["street1"] !== undefined ? _data["street1"] : null as any;
            this.street2 = _data["street2"] !== undefined ? _data["street2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
        }
    }

    static fromJS(data: any): AgentContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["street1"] = this.street1 !== undefined ? this.street1 : null as any;
        data["street2"] = this.street2 !== undefined ? this.street2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        return data;
    }
}

export interface IAgentContactDto {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    fullName?: string | null;
    address?: string | null;

    [key: string]: any;
}

export class AgentCrmCommandApproval implements IAgentCrmCommandApproval {
    approvalId?: string;
    approvedByUserId?: number;
    approvedAtUtc?: DateTime;
    approvedCommandHash?: string;
    approvalSource?: string;

    [key: string]: any;

    constructor(data?: IAgentCrmCommandApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.approvedByUserId = _data["approvedByUserId"] !== undefined ? _data["approvedByUserId"] : null as any;
            this.approvedAtUtc = _data["approvedAtUtc"] ? DateTime.fromISO(_data["approvedAtUtc"].toString()) : null as any;
            this.approvedCommandHash = _data["approvedCommandHash"] !== undefined ? _data["approvedCommandHash"] : null as any;
            this.approvalSource = _data["approvalSource"] !== undefined ? _data["approvalSource"] : null as any;
        }
    }

    static fromJS(data: any): AgentCrmCommandApproval {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCrmCommandApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["approvedByUserId"] = this.approvedByUserId !== undefined ? this.approvedByUserId : null as any;
        data["approvedAtUtc"] = this.approvedAtUtc ? this.approvedAtUtc.toString() : null as any;
        data["approvedCommandHash"] = this.approvedCommandHash !== undefined ? this.approvedCommandHash : null as any;
        data["approvalSource"] = this.approvalSource !== undefined ? this.approvalSource : null as any;
        return data;
    }
}

export interface IAgentCrmCommandApproval {
    approvalId?: string;
    approvedByUserId?: number;
    approvedAtUtc?: DateTime;
    approvedCommandHash?: string;
    approvalSource?: string;

    [key: string]: any;
}

export class AgentCrmCommandEvidenceCitation implements IAgentCrmCommandEvidenceCitation {
    source?: string;
    reference?: string;
    title?: string | null;
    quote?: string | null;

    [key: string]: any;

    constructor(data?: IAgentCrmCommandEvidenceCitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.reference = _data["reference"] !== undefined ? _data["reference"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.quote = _data["quote"] !== undefined ? _data["quote"] : null as any;
        }
    }

    static fromJS(data: any): AgentCrmCommandEvidenceCitation {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCrmCommandEvidenceCitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["reference"] = this.reference !== undefined ? this.reference : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["quote"] = this.quote !== undefined ? this.quote : null as any;
        return data;
    }
}

export interface IAgentCrmCommandEvidenceCitation {
    source?: string;
    reference?: string;
    title?: string | null;
    quote?: string | null;

    [key: string]: any;
}

export class AgentCrmCommandPreviewResult implements IAgentCrmCommandPreviewResult {
    commandId?: string;
    idempotencyKey?: string;
    customerId?: number;
    claimId?: number;
    agentName?: string;
    actorUserId?: number;
    commandType?: string;
    schemaVersion?: string;
    approvalCommandHash?: string;
    mutationSummary?: string;
    expectedClaimStatusId?: number | null;
    evidenceCitations?: AgentCrmCommandEvidenceCitation[];

    [key: string]: any;

    constructor(data?: IAgentCrmCommandPreviewResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.commandId = _data["commandId"] !== undefined ? _data["commandId"] : null as any;
            this.idempotencyKey = _data["idempotencyKey"] !== undefined ? _data["idempotencyKey"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.agentName = _data["agentName"] !== undefined ? _data["agentName"] : null as any;
            this.actorUserId = _data["actorUserId"] !== undefined ? _data["actorUserId"] : null as any;
            this.commandType = _data["commandType"] !== undefined ? _data["commandType"] : null as any;
            this.schemaVersion = _data["schemaVersion"] !== undefined ? _data["schemaVersion"] : null as any;
            this.approvalCommandHash = _data["approvalCommandHash"] !== undefined ? _data["approvalCommandHash"] : null as any;
            this.mutationSummary = _data["mutationSummary"] !== undefined ? _data["mutationSummary"] : null as any;
            this.expectedClaimStatusId = _data["expectedClaimStatusId"] !== undefined ? _data["expectedClaimStatusId"] : null as any;
            if (Array.isArray(_data["evidenceCitations"])) {
                this.evidenceCitations = [] as any;
                for (let item of _data["evidenceCitations"])
                    this.evidenceCitations!.push(AgentCrmCommandEvidenceCitation.fromJS(item));
            }
            else {
                this.evidenceCitations = null as any;
            }
        }
    }

    static fromJS(data: any): AgentCrmCommandPreviewResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCrmCommandPreviewResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["commandId"] = this.commandId !== undefined ? this.commandId : null as any;
        data["idempotencyKey"] = this.idempotencyKey !== undefined ? this.idempotencyKey : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["agentName"] = this.agentName !== undefined ? this.agentName : null as any;
        data["actorUserId"] = this.actorUserId !== undefined ? this.actorUserId : null as any;
        data["commandType"] = this.commandType !== undefined ? this.commandType : null as any;
        data["schemaVersion"] = this.schemaVersion !== undefined ? this.schemaVersion : null as any;
        data["approvalCommandHash"] = this.approvalCommandHash !== undefined ? this.approvalCommandHash : null as any;
        data["mutationSummary"] = this.mutationSummary !== undefined ? this.mutationSummary : null as any;
        data["expectedClaimStatusId"] = this.expectedClaimStatusId !== undefined ? this.expectedClaimStatusId : null as any;
        if (Array.isArray(this.evidenceCitations)) {
            data["evidenceCitations"] = [];
            for (let item of this.evidenceCitations)
                data["evidenceCitations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentCrmCommandPreviewResult {
    commandId?: string;
    idempotencyKey?: string;
    customerId?: number;
    claimId?: number;
    agentName?: string;
    actorUserId?: number;
    commandType?: string;
    schemaVersion?: string;
    approvalCommandHash?: string;
    mutationSummary?: string;
    expectedClaimStatusId?: number | null;
    evidenceCitations?: AgentCrmCommandEvidenceCitation[];

    [key: string]: any;
}

export class AgentCrmCommandRequest implements IAgentCrmCommandRequest {
    commandId?: string;
    idempotencyKey?: string;
    customerId?: number;
    claimId?: number;
    agentName?: string;
    actorUserId?: number;
    approval?: AgentCrmCommandApproval | null;
    commandType?: string;
    schemaVersion?: string;
    payload?: JsonElement;
    evidenceCitations?: AgentCrmCommandEvidenceCitation[];

    [key: string]: any;

    constructor(data?: IAgentCrmCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.commandId = _data["commandId"] !== undefined ? _data["commandId"] : null as any;
            this.idempotencyKey = _data["idempotencyKey"] !== undefined ? _data["idempotencyKey"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.agentName = _data["agentName"] !== undefined ? _data["agentName"] : null as any;
            this.actorUserId = _data["actorUserId"] !== undefined ? _data["actorUserId"] : null as any;
            this.approval = _data["approval"] ? AgentCrmCommandApproval.fromJS(_data["approval"]) : null as any;
            this.commandType = _data["commandType"] !== undefined ? _data["commandType"] : null as any;
            this.schemaVersion = _data["schemaVersion"] !== undefined ? _data["schemaVersion"] : null as any;
            this.payload = _data["payload"] ? JsonElement.fromJS(_data["payload"]) : null as any;
            if (Array.isArray(_data["evidenceCitations"])) {
                this.evidenceCitations = [] as any;
                for (let item of _data["evidenceCitations"])
                    this.evidenceCitations!.push(AgentCrmCommandEvidenceCitation.fromJS(item));
            }
            else {
                this.evidenceCitations = null as any;
            }
        }
    }

    static fromJS(data: any): AgentCrmCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCrmCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["commandId"] = this.commandId !== undefined ? this.commandId : null as any;
        data["idempotencyKey"] = this.idempotencyKey !== undefined ? this.idempotencyKey : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["agentName"] = this.agentName !== undefined ? this.agentName : null as any;
        data["actorUserId"] = this.actorUserId !== undefined ? this.actorUserId : null as any;
        data["approval"] = this.approval ? this.approval.toJSON() : null as any;
        data["commandType"] = this.commandType !== undefined ? this.commandType : null as any;
        data["schemaVersion"] = this.schemaVersion !== undefined ? this.schemaVersion : null as any;
        data["payload"] = this.payload ? this.payload.toJSON() : null as any;
        if (Array.isArray(this.evidenceCitations)) {
            data["evidenceCitations"] = [];
            for (let item of this.evidenceCitations)
                data["evidenceCitations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentCrmCommandRequest {
    commandId?: string;
    idempotencyKey?: string;
    customerId?: number;
    claimId?: number;
    agentName?: string;
    actorUserId?: number;
    approval?: AgentCrmCommandApproval | null;
    commandType?: string;
    schemaVersion?: string;
    payload?: JsonElement;
    evidenceCitations?: AgentCrmCommandEvidenceCitation[];

    [key: string]: any;
}

export class AgentCrmCommandResult implements IAgentCrmCommandResult {
    commandId?: string;
    idempotencyKey?: string;
    customerId?: number;
    claimId?: number | null;
    agentName?: string;
    actorUserId?: number;
    approvalId?: string;
    commandType?: string;
    schemaVersion?: string;
    status?: string;
    commandHash?: string;
    resultEntityName?: string | null;
    resultEntityId?: number | null;
    resultingCrmEventType?: string | null;
    executedAtUtc?: DateTime | null;
    duplicate?: boolean;

    [key: string]: any;

    constructor(data?: IAgentCrmCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.commandId = _data["commandId"] !== undefined ? _data["commandId"] : null as any;
            this.idempotencyKey = _data["idempotencyKey"] !== undefined ? _data["idempotencyKey"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.agentName = _data["agentName"] !== undefined ? _data["agentName"] : null as any;
            this.actorUserId = _data["actorUserId"] !== undefined ? _data["actorUserId"] : null as any;
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.commandType = _data["commandType"] !== undefined ? _data["commandType"] : null as any;
            this.schemaVersion = _data["schemaVersion"] !== undefined ? _data["schemaVersion"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.commandHash = _data["commandHash"] !== undefined ? _data["commandHash"] : null as any;
            this.resultEntityName = _data["resultEntityName"] !== undefined ? _data["resultEntityName"] : null as any;
            this.resultEntityId = _data["resultEntityId"] !== undefined ? _data["resultEntityId"] : null as any;
            this.resultingCrmEventType = _data["resultingCrmEventType"] !== undefined ? _data["resultingCrmEventType"] : null as any;
            this.executedAtUtc = _data["executedAtUtc"] ? DateTime.fromISO(_data["executedAtUtc"].toString()) : null as any;
            this.duplicate = _data["duplicate"] !== undefined ? _data["duplicate"] : null as any;
        }
    }

    static fromJS(data: any): AgentCrmCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCrmCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["commandId"] = this.commandId !== undefined ? this.commandId : null as any;
        data["idempotencyKey"] = this.idempotencyKey !== undefined ? this.idempotencyKey : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["agentName"] = this.agentName !== undefined ? this.agentName : null as any;
        data["actorUserId"] = this.actorUserId !== undefined ? this.actorUserId : null as any;
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["commandType"] = this.commandType !== undefined ? this.commandType : null as any;
        data["schemaVersion"] = this.schemaVersion !== undefined ? this.schemaVersion : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["commandHash"] = this.commandHash !== undefined ? this.commandHash : null as any;
        data["resultEntityName"] = this.resultEntityName !== undefined ? this.resultEntityName : null as any;
        data["resultEntityId"] = this.resultEntityId !== undefined ? this.resultEntityId : null as any;
        data["resultingCrmEventType"] = this.resultingCrmEventType !== undefined ? this.resultingCrmEventType : null as any;
        data["executedAtUtc"] = this.executedAtUtc ? this.executedAtUtc.toString() : null as any;
        data["duplicate"] = this.duplicate !== undefined ? this.duplicate : null as any;
        return data;
    }
}

export interface IAgentCrmCommandResult {
    commandId?: string;
    idempotencyKey?: string;
    customerId?: number;
    claimId?: number | null;
    agentName?: string;
    actorUserId?: number;
    approvalId?: string;
    commandType?: string;
    schemaVersion?: string;
    status?: string;
    commandHash?: string;
    resultEntityName?: string | null;
    resultEntityId?: number | null;
    resultingCrmEventType?: string | null;
    executedAtUtc?: DateTime | null;
    duplicate?: boolean;

    [key: string]: any;
}

export class AgentDocumentDigestFactDto implements IAgentDocumentDigestFactDto {
    label?: string | null;
    value?: string | null;

    [key: string]: any;

    constructor(data?: IAgentDocumentDigestFactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): AgentDocumentDigestFactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDocumentDigestFactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface IAgentDocumentDigestFactDto {
    label?: string | null;
    value?: string | null;

    [key: string]: any;
}

export class AgentDocumentDigestSectionDto implements IAgentDocumentDigestSectionDto {
    title?: string | null;
    summary?: string | null;
    pageStart?: number | null;
    pageEnd?: number | null;

    [key: string]: any;

    constructor(data?: IAgentDocumentDigestSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.pageStart = _data["pageStart"] !== undefined ? _data["pageStart"] : null as any;
            this.pageEnd = _data["pageEnd"] !== undefined ? _data["pageEnd"] : null as any;
        }
    }

    static fromJS(data: any): AgentDocumentDigestSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDocumentDigestSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["pageStart"] = this.pageStart !== undefined ? this.pageStart : null as any;
        data["pageEnd"] = this.pageEnd !== undefined ? this.pageEnd : null as any;
        return data;
    }
}

export interface IAgentDocumentDigestSectionDto {
    title?: string | null;
    summary?: string | null;
    pageStart?: number | null;
    pageEnd?: number | null;

    [key: string]: any;
}

export class AgentDocumentIntelligenceDigestDto implements IAgentDocumentIntelligenceDigestDto {
    summary?: string | null;
    primaryDocumentKind?: string | null;
    documentKinds?: string[];
    sections?: AgentDocumentDigestSectionDto[];
    facts?: AgentDocumentDigestFactDto[];
    truncated?: boolean;

    [key: string]: any;

    constructor(data?: IAgentDocumentIntelligenceDigestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.primaryDocumentKind = _data["primaryDocumentKind"] !== undefined ? _data["primaryDocumentKind"] : null as any;
            if (Array.isArray(_data["documentKinds"])) {
                this.documentKinds = [] as any;
                for (let item of _data["documentKinds"])
                    this.documentKinds!.push(item);
            }
            else {
                this.documentKinds = null as any;
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(AgentDocumentDigestSectionDto.fromJS(item));
            }
            else {
                this.sections = null as any;
            }
            if (Array.isArray(_data["facts"])) {
                this.facts = [] as any;
                for (let item of _data["facts"])
                    this.facts!.push(AgentDocumentDigestFactDto.fromJS(item));
            }
            else {
                this.facts = null as any;
            }
            this.truncated = _data["truncated"] !== undefined ? _data["truncated"] : null as any;
        }
    }

    static fromJS(data: any): AgentDocumentIntelligenceDigestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDocumentIntelligenceDigestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["primaryDocumentKind"] = this.primaryDocumentKind !== undefined ? this.primaryDocumentKind : null as any;
        if (Array.isArray(this.documentKinds)) {
            data["documentKinds"] = [];
            for (let item of this.documentKinds)
                data["documentKinds"].push(item);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.facts)) {
            data["facts"] = [];
            for (let item of this.facts)
                data["facts"].push(item ? item.toJSON() : null as any);
        }
        data["truncated"] = this.truncated !== undefined ? this.truncated : null as any;
        return data;
    }
}

export interface IAgentDocumentIntelligenceDigestDto {
    summary?: string | null;
    primaryDocumentKind?: string | null;
    documentKinds?: string[];
    sections?: AgentDocumentDigestSectionDto[];
    facts?: AgentDocumentDigestFactDto[];
    truncated?: boolean;

    [key: string]: any;
}

export class AgentEventRoute implements IAgentEventRoute {
    agentType?: string | null;
    agentName?: string | null;
    reason?: string | null;

    [key: string]: any;

    constructor(data?: IAgentEventRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agentType = _data["agentType"] !== undefined ? _data["agentType"] : null as any;
            this.agentName = _data["agentName"] !== undefined ? _data["agentName"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static fromJS(data: any): AgentEventRoute {
        data = typeof data === 'object' ? data : {};
        let result = new AgentEventRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agentType"] = this.agentType !== undefined ? this.agentType : null as any;
        data["agentName"] = this.agentName !== undefined ? this.agentName : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        return data;
    }
}

export interface IAgentEventRoute {
    agentType?: string | null;
    agentName?: string | null;
    reason?: string | null;

    [key: string]: any;
}

export class AgentMentionReferenceDto implements IAgentMentionReferenceDto {
    userId?: number;
    label?: string;

    [key: string]: any;

    constructor(data?: IAgentMentionReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
        }
    }

    static fromJS(data: any): AgentMentionReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMentionReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        return data;
    }
}

export interface IAgentMentionReferenceDto {
    userId?: number;
    label?: string;

    [key: string]: any;
}

export class AgentMosaicClaimContactEditDto implements IAgentMosaicClaimContactEditDto {
    contactId?: number;
    claimContactId?: number;
    isUser?: boolean;
    contact?: AgentClaimContactDetailsPayload;
    contactSection?: string;
    contactTypeId?: number | null;
    claimRoleIds?: number[];

    [key: string]: any;

    constructor(data?: IAgentMosaicClaimContactEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.contactId = _data["contactId"] !== undefined ? _data["contactId"] : null as any;
            this.claimContactId = _data["claimContactId"] !== undefined ? _data["claimContactId"] : null as any;
            this.isUser = _data["isUser"] !== undefined ? _data["isUser"] : null as any;
            this.contact = _data["contact"] ? AgentClaimContactDetailsPayload.fromJS(_data["contact"]) : null as any;
            this.contactSection = _data["contactSection"] !== undefined ? _data["contactSection"] : null as any;
            this.contactTypeId = _data["contactTypeId"] !== undefined ? _data["contactTypeId"] : null as any;
            if (Array.isArray(_data["claimRoleIds"])) {
                this.claimRoleIds = [] as any;
                for (let item of _data["claimRoleIds"])
                    this.claimRoleIds!.push(item);
            }
            else {
                this.claimRoleIds = null as any;
            }
        }
    }

    static fromJS(data: any): AgentMosaicClaimContactEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMosaicClaimContactEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["contactId"] = this.contactId !== undefined ? this.contactId : null as any;
        data["claimContactId"] = this.claimContactId !== undefined ? this.claimContactId : null as any;
        data["isUser"] = this.isUser !== undefined ? this.isUser : null as any;
        data["contact"] = this.contact ? this.contact.toJSON() : null as any;
        data["contactSection"] = this.contactSection !== undefined ? this.contactSection : null as any;
        data["contactTypeId"] = this.contactTypeId !== undefined ? this.contactTypeId : null as any;
        if (Array.isArray(this.claimRoleIds)) {
            data["claimRoleIds"] = [];
            for (let item of this.claimRoleIds)
                data["claimRoleIds"].push(item);
        }
        return data;
    }
}

export interface IAgentMosaicClaimContactEditDto {
    contactId?: number;
    claimContactId?: number;
    isUser?: boolean;
    contact?: AgentClaimContactDetailsPayload;
    contactSection?: string;
    contactTypeId?: number | null;
    claimRoleIds?: number[];

    [key: string]: any;
}

export class AgentMosaicContactSearchResult implements IAgentMosaicContactSearchResult {
    id?: number;
    fullName?: string;
    email?: string | null;
    phoneNumber?: string | null;
    isUser?: boolean;
    isLinkedToClaim?: boolean;

    [key: string]: any;

    constructor(data?: IAgentMosaicContactSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.isUser = _data["isUser"] !== undefined ? _data["isUser"] : null as any;
            this.isLinkedToClaim = _data["isLinkedToClaim"] !== undefined ? _data["isLinkedToClaim"] : null as any;
        }
    }

    static fromJS(data: any): AgentMosaicContactSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMosaicContactSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["isUser"] = this.isUser !== undefined ? this.isUser : null as any;
        data["isLinkedToClaim"] = this.isLinkedToClaim !== undefined ? this.isLinkedToClaim : null as any;
        return data;
    }
}

export interface IAgentMosaicContactSearchResult {
    id?: number;
    fullName?: string;
    email?: string | null;
    phoneNumber?: string | null;
    isUser?: boolean;
    isLinkedToClaim?: boolean;

    [key: string]: any;
}

export class AgentMosaicContactTaskMutationOptions implements IAgentMosaicContactTaskMutationOptions {
    permissions?: AgentMosaicMutationPermissions;
    activeUsers?: AgentMosaicOption[];
    contactTypes?: AgentMosaicOption[];
    claimRoles?: AgentMosaicOption[];

    [key: string]: any;

    constructor(data?: IAgentMosaicContactTaskMutationOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.permissions = _data["permissions"] ? AgentMosaicMutationPermissions.fromJS(_data["permissions"]) : null as any;
            if (Array.isArray(_data["activeUsers"])) {
                this.activeUsers = [] as any;
                for (let item of _data["activeUsers"])
                    this.activeUsers!.push(AgentMosaicOption.fromJS(item));
            }
            else {
                this.activeUsers = null as any;
            }
            if (Array.isArray(_data["contactTypes"])) {
                this.contactTypes = [] as any;
                for (let item of _data["contactTypes"])
                    this.contactTypes!.push(AgentMosaicOption.fromJS(item));
            }
            else {
                this.contactTypes = null as any;
            }
            if (Array.isArray(_data["claimRoles"])) {
                this.claimRoles = [] as any;
                for (let item of _data["claimRoles"])
                    this.claimRoles!.push(AgentMosaicOption.fromJS(item));
            }
            else {
                this.claimRoles = null as any;
            }
        }
    }

    static fromJS(data: any): AgentMosaicContactTaskMutationOptions {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMosaicContactTaskMutationOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["permissions"] = this.permissions ? this.permissions.toJSON() : null as any;
        if (Array.isArray(this.activeUsers)) {
            data["activeUsers"] = [];
            for (let item of this.activeUsers)
                data["activeUsers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.contactTypes)) {
            data["contactTypes"] = [];
            for (let item of this.contactTypes)
                data["contactTypes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.claimRoles)) {
            data["claimRoles"] = [];
            for (let item of this.claimRoles)
                data["claimRoles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentMosaicContactTaskMutationOptions {
    permissions?: AgentMosaicMutationPermissions;
    activeUsers?: AgentMosaicOption[];
    contactTypes?: AgentMosaicOption[];
    claimRoles?: AgentMosaicOption[];

    [key: string]: any;
}

export class AgentMosaicMutationPermissions implements IAgentMosaicMutationPermissions {
    canCreateContact?: boolean;
    canUpdateContact?: boolean;
    canLinkContact?: boolean;
    canUnlinkContact?: boolean;
    canCreateTask?: boolean;
    canUpdateTask?: boolean;
    canDeleteTask?: boolean;

    [key: string]: any;

    constructor(data?: IAgentMosaicMutationPermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.canCreateContact = _data["canCreateContact"] !== undefined ? _data["canCreateContact"] : null as any;
            this.canUpdateContact = _data["canUpdateContact"] !== undefined ? _data["canUpdateContact"] : null as any;
            this.canLinkContact = _data["canLinkContact"] !== undefined ? _data["canLinkContact"] : null as any;
            this.canUnlinkContact = _data["canUnlinkContact"] !== undefined ? _data["canUnlinkContact"] : null as any;
            this.canCreateTask = _data["canCreateTask"] !== undefined ? _data["canCreateTask"] : null as any;
            this.canUpdateTask = _data["canUpdateTask"] !== undefined ? _data["canUpdateTask"] : null as any;
            this.canDeleteTask = _data["canDeleteTask"] !== undefined ? _data["canDeleteTask"] : null as any;
        }
    }

    static fromJS(data: any): AgentMosaicMutationPermissions {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMosaicMutationPermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["canCreateContact"] = this.canCreateContact !== undefined ? this.canCreateContact : null as any;
        data["canUpdateContact"] = this.canUpdateContact !== undefined ? this.canUpdateContact : null as any;
        data["canLinkContact"] = this.canLinkContact !== undefined ? this.canLinkContact : null as any;
        data["canUnlinkContact"] = this.canUnlinkContact !== undefined ? this.canUnlinkContact : null as any;
        data["canCreateTask"] = this.canCreateTask !== undefined ? this.canCreateTask : null as any;
        data["canUpdateTask"] = this.canUpdateTask !== undefined ? this.canUpdateTask : null as any;
        data["canDeleteTask"] = this.canDeleteTask !== undefined ? this.canDeleteTask : null as any;
        return data;
    }
}

export interface IAgentMosaicMutationPermissions {
    canCreateContact?: boolean;
    canUpdateContact?: boolean;
    canLinkContact?: boolean;
    canUnlinkContact?: boolean;
    canCreateTask?: boolean;
    canUpdateTask?: boolean;
    canDeleteTask?: boolean;

    [key: string]: any;
}

export class AgentMosaicOption implements IAgentMosaicOption {
    id?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: IAgentMosaicOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): AgentMosaicOption {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMosaicOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IAgentMosaicOption {
    id?: number;
    name?: string;

    [key: string]: any;
}

export class AgentMosaicReceiverDispatchMetadata implements IAgentMosaicReceiverDispatchMetadata {
    inboxName?: string | null;
    dispatchedAt?: string | null;

    [key: string]: any;

    constructor(data?: IAgentMosaicReceiverDispatchMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.inboxName = _data["inboxName"] !== undefined ? _data["inboxName"] : null as any;
            this.dispatchedAt = _data["dispatchedAt"] !== undefined ? _data["dispatchedAt"] : null as any;
        }
    }

    static fromJS(data: any): AgentMosaicReceiverDispatchMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMosaicReceiverDispatchMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["inboxName"] = this.inboxName !== undefined ? this.inboxName : null as any;
        data["dispatchedAt"] = this.dispatchedAt !== undefined ? this.dispatchedAt : null as any;
        return data;
    }
}

export interface IAgentMosaicReceiverDispatchMetadata {
    inboxName?: string | null;
    dispatchedAt?: string | null;

    [key: string]: any;
}

export class AgentMyClaimsSummaryDto implements IAgentMyClaimsSummaryDto {
    activeClaimCount?: number;
    openTaskCount?: number;
    overdueTaskCount?: number;
    tasksDueNext7DaysCount?: number;

    [key: string]: any;

    constructor(data?: IAgentMyClaimsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.activeClaimCount = _data["activeClaimCount"] !== undefined ? _data["activeClaimCount"] : null as any;
            this.openTaskCount = _data["openTaskCount"] !== undefined ? _data["openTaskCount"] : null as any;
            this.overdueTaskCount = _data["overdueTaskCount"] !== undefined ? _data["overdueTaskCount"] : null as any;
            this.tasksDueNext7DaysCount = _data["tasksDueNext7DaysCount"] !== undefined ? _data["tasksDueNext7DaysCount"] : null as any;
        }
    }

    static fromJS(data: any): AgentMyClaimsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentMyClaimsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["activeClaimCount"] = this.activeClaimCount !== undefined ? this.activeClaimCount : null as any;
        data["openTaskCount"] = this.openTaskCount !== undefined ? this.openTaskCount : null as any;
        data["overdueTaskCount"] = this.overdueTaskCount !== undefined ? this.overdueTaskCount : null as any;
        data["tasksDueNext7DaysCount"] = this.tasksDueNext7DaysCount !== undefined ? this.tasksDueNext7DaysCount : null as any;
        return data;
    }
}

export interface IAgentMyClaimsSummaryDto {
    activeClaimCount?: number;
    openTaskCount?: number;
    overdueTaskCount?: number;
    tasksDueNext7DaysCount?: number;

    [key: string]: any;
}

export class AgentPolicyDocumentContextDto implements IAgentPolicyDocumentContextDto {
    attachmentId?: number;
    fileName?: string;
    label?: string | null;
    folderName?: string | null;
    identifiedBy?: string;
    processedWhen?: DateTime | null;
    structuredExtraction?: AgentPolicyStructuredExtractionDto | null;
    intelligenceDigest?: AgentDocumentIntelligenceDigestDto | null;
    extractedTextAvailable?: boolean;

    [key: string]: any;

    constructor(data?: IAgentPolicyDocumentContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.attachmentId = _data["attachmentId"] !== undefined ? _data["attachmentId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.folderName = _data["folderName"] !== undefined ? _data["folderName"] : null as any;
            this.identifiedBy = _data["identifiedBy"] !== undefined ? _data["identifiedBy"] : null as any;
            this.processedWhen = _data["processedWhen"] ? DateTime.fromISO(_data["processedWhen"].toString()) : null as any;
            this.structuredExtraction = _data["structuredExtraction"] ? AgentPolicyStructuredExtractionDto.fromJS(_data["structuredExtraction"]) : null as any;
            this.intelligenceDigest = _data["intelligenceDigest"] ? AgentDocumentIntelligenceDigestDto.fromJS(_data["intelligenceDigest"]) : null as any;
            this.extractedTextAvailable = _data["extractedTextAvailable"] !== undefined ? _data["extractedTextAvailable"] : null as any;
        }
    }

    static fromJS(data: any): AgentPolicyDocumentContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentPolicyDocumentContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["folderName"] = this.folderName !== undefined ? this.folderName : null as any;
        data["identifiedBy"] = this.identifiedBy !== undefined ? this.identifiedBy : null as any;
        data["processedWhen"] = this.processedWhen ? this.processedWhen.toString() : null as any;
        data["structuredExtraction"] = this.structuredExtraction ? this.structuredExtraction.toJSON() : null as any;
        data["intelligenceDigest"] = this.intelligenceDigest ? this.intelligenceDigest.toJSON() : null as any;
        data["extractedTextAvailable"] = this.extractedTextAvailable !== undefined ? this.extractedTextAvailable : null as any;
        return data;
    }
}

export interface IAgentPolicyDocumentContextDto {
    attachmentId?: number;
    fileName?: string;
    label?: string | null;
    folderName?: string | null;
    identifiedBy?: string;
    processedWhen?: DateTime | null;
    structuredExtraction?: AgentPolicyStructuredExtractionDto | null;
    intelligenceDigest?: AgentDocumentIntelligenceDigestDto | null;
    extractedTextAvailable?: boolean;

    [key: string]: any;
}

export class AgentPolicyStructuredExtractionDto implements IAgentPolicyStructuredExtractionDto {
    policyNumber?: string | null;
    policyStartDate?: string | null;
    policyEndDate?: string | null;
    dwellingCoverageA?: number | null;
    otherStructuresCoverageB?: number | null;
    personalPropertyCoverageC?: number | null;
    lossOfUseRentOrAleCoverageD?: number | null;
    ordinanceAndLawPercentage?: number | null;
    debrisRemoval?: number | null;
    debrisRemovalIsPercentage?: boolean | null;
    moldFungiLimit?: number | null;
    backupLimit?: number | null;
    waterLimit?: number | null;
    deductible?: number | null;
    appraisalClause?: string | null;
    primaryPolicyHolderName?: string | null;
    secondaryPolicyHolderName?: string | null;
    agentName?: string | null;
    insuranceCompanyName?: string | null;
    mortgageCompanyName?: string | null;

    [key: string]: any;

    constructor(data?: IAgentPolicyStructuredExtractionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.policyNumber = _data["policyNumber"] !== undefined ? _data["policyNumber"] : null as any;
            this.policyStartDate = _data["policyStartDate"] !== undefined ? _data["policyStartDate"] : null as any;
            this.policyEndDate = _data["policyEndDate"] !== undefined ? _data["policyEndDate"] : null as any;
            this.dwellingCoverageA = _data["dwellingCoverageA"] !== undefined ? _data["dwellingCoverageA"] : null as any;
            this.otherStructuresCoverageB = _data["otherStructuresCoverageB"] !== undefined ? _data["otherStructuresCoverageB"] : null as any;
            this.personalPropertyCoverageC = _data["personalPropertyCoverageC"] !== undefined ? _data["personalPropertyCoverageC"] : null as any;
            this.lossOfUseRentOrAleCoverageD = _data["lossOfUseRentOrAleCoverageD"] !== undefined ? _data["lossOfUseRentOrAleCoverageD"] : null as any;
            this.ordinanceAndLawPercentage = _data["ordinanceAndLawPercentage"] !== undefined ? _data["ordinanceAndLawPercentage"] : null as any;
            this.debrisRemoval = _data["debrisRemoval"] !== undefined ? _data["debrisRemoval"] : null as any;
            this.debrisRemovalIsPercentage = _data["debrisRemovalIsPercentage"] !== undefined ? _data["debrisRemovalIsPercentage"] : null as any;
            this.moldFungiLimit = _data["moldFungiLimit"] !== undefined ? _data["moldFungiLimit"] : null as any;
            this.backupLimit = _data["backupLimit"] !== undefined ? _data["backupLimit"] : null as any;
            this.waterLimit = _data["waterLimit"] !== undefined ? _data["waterLimit"] : null as any;
            this.deductible = _data["deductible"] !== undefined ? _data["deductible"] : null as any;
            this.appraisalClause = _data["appraisalClause"] !== undefined ? _data["appraisalClause"] : null as any;
            this.primaryPolicyHolderName = _data["primaryPolicyHolderName"] !== undefined ? _data["primaryPolicyHolderName"] : null as any;
            this.secondaryPolicyHolderName = _data["secondaryPolicyHolderName"] !== undefined ? _data["secondaryPolicyHolderName"] : null as any;
            this.agentName = _data["agentName"] !== undefined ? _data["agentName"] : null as any;
            this.insuranceCompanyName = _data["insuranceCompanyName"] !== undefined ? _data["insuranceCompanyName"] : null as any;
            this.mortgageCompanyName = _data["mortgageCompanyName"] !== undefined ? _data["mortgageCompanyName"] : null as any;
        }
    }

    static fromJS(data: any): AgentPolicyStructuredExtractionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentPolicyStructuredExtractionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["policyNumber"] = this.policyNumber !== undefined ? this.policyNumber : null as any;
        data["policyStartDate"] = this.policyStartDate !== undefined ? this.policyStartDate : null as any;
        data["policyEndDate"] = this.policyEndDate !== undefined ? this.policyEndDate : null as any;
        data["dwellingCoverageA"] = this.dwellingCoverageA !== undefined ? this.dwellingCoverageA : null as any;
        data["otherStructuresCoverageB"] = this.otherStructuresCoverageB !== undefined ? this.otherStructuresCoverageB : null as any;
        data["personalPropertyCoverageC"] = this.personalPropertyCoverageC !== undefined ? this.personalPropertyCoverageC : null as any;
        data["lossOfUseRentOrAleCoverageD"] = this.lossOfUseRentOrAleCoverageD !== undefined ? this.lossOfUseRentOrAleCoverageD : null as any;
        data["ordinanceAndLawPercentage"] = this.ordinanceAndLawPercentage !== undefined ? this.ordinanceAndLawPercentage : null as any;
        data["debrisRemoval"] = this.debrisRemoval !== undefined ? this.debrisRemoval : null as any;
        data["debrisRemovalIsPercentage"] = this.debrisRemovalIsPercentage !== undefined ? this.debrisRemovalIsPercentage : null as any;
        data["moldFungiLimit"] = this.moldFungiLimit !== undefined ? this.moldFungiLimit : null as any;
        data["backupLimit"] = this.backupLimit !== undefined ? this.backupLimit : null as any;
        data["waterLimit"] = this.waterLimit !== undefined ? this.waterLimit : null as any;
        data["deductible"] = this.deductible !== undefined ? this.deductible : null as any;
        data["appraisalClause"] = this.appraisalClause !== undefined ? this.appraisalClause : null as any;
        data["primaryPolicyHolderName"] = this.primaryPolicyHolderName !== undefined ? this.primaryPolicyHolderName : null as any;
        data["secondaryPolicyHolderName"] = this.secondaryPolicyHolderName !== undefined ? this.secondaryPolicyHolderName : null as any;
        data["agentName"] = this.agentName !== undefined ? this.agentName : null as any;
        data["insuranceCompanyName"] = this.insuranceCompanyName !== undefined ? this.insuranceCompanyName : null as any;
        data["mortgageCompanyName"] = this.mortgageCompanyName !== undefined ? this.mortgageCompanyName : null as any;
        return data;
    }
}

export interface IAgentPolicyStructuredExtractionDto {
    policyNumber?: string | null;
    policyStartDate?: string | null;
    policyEndDate?: string | null;
    dwellingCoverageA?: number | null;
    otherStructuresCoverageB?: number | null;
    personalPropertyCoverageC?: number | null;
    lossOfUseRentOrAleCoverageD?: number | null;
    ordinanceAndLawPercentage?: number | null;
    debrisRemoval?: number | null;
    debrisRemovalIsPercentage?: boolean | null;
    moldFungiLimit?: number | null;
    backupLimit?: number | null;
    waterLimit?: number | null;
    deductible?: number | null;
    appraisalClause?: string | null;
    primaryPolicyHolderName?: string | null;
    secondaryPolicyHolderName?: string | null;
    agentName?: string | null;
    insuranceCompanyName?: string | null;
    mortgageCompanyName?: string | null;

    [key: string]: any;
}

export class AgentRuntimeCrmEvent implements IAgentRuntimeCrmEvent {
    specversion?: string | null;
    id?: string | null;
    source?: string | null;
    type?: string | null;
    subject?: string | null;
    time?: string | null;
    dataschema?: string | null;
    data?: AgentRuntimeCrmEventData | null;
    route?: AgentRuntimeCrmEventRoute | null;
    receiver?: AgentMosaicReceiverDispatchMetadata | null;

    [key: string]: any;

    constructor(data?: IAgentRuntimeCrmEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.specversion = _data["specversion"] !== undefined ? _data["specversion"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.time = _data["time"] !== undefined ? _data["time"] : null as any;
            this.dataschema = _data["dataschema"] !== undefined ? _data["dataschema"] : null as any;
            this.data = _data["data"] ? AgentRuntimeCrmEventData.fromJS(_data["data"]) : null as any;
            this.route = _data["route"] ? AgentRuntimeCrmEventRoute.fromJS(_data["route"]) : null as any;
            this.receiver = _data["receiver"] ? AgentMosaicReceiverDispatchMetadata.fromJS(_data["receiver"]) : null as any;
        }
    }

    static fromJS(data: any): AgentRuntimeCrmEvent {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRuntimeCrmEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["specversion"] = this.specversion !== undefined ? this.specversion : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["time"] = this.time !== undefined ? this.time : null as any;
        data["dataschema"] = this.dataschema !== undefined ? this.dataschema : null as any;
        data["data"] = this.data ? this.data.toJSON() : null as any;
        data["route"] = this.route ? this.route.toJSON() : null as any;
        data["receiver"] = this.receiver ? this.receiver.toJSON() : null as any;
        return data;
    }
}

export interface IAgentRuntimeCrmEvent {
    specversion?: string | null;
    id?: string | null;
    source?: string | null;
    type?: string | null;
    subject?: string | null;
    time?: string | null;
    dataschema?: string | null;
    data?: AgentRuntimeCrmEventData | null;
    route?: AgentRuntimeCrmEventRoute | null;
    receiver?: AgentMosaicReceiverDispatchMetadata | null;

    [key: string]: any;
}

export class AgentRuntimeCrmEventData implements IAgentRuntimeCrmEventData {
    schemaVersion?: string | null;
    customerId?: number;
    claimId?: number | null;
    carrierCompanyId?: number | null;
    entityName?: string | null;
    entityId?: number;
    operation?: string | null;
    actorUserId?: number | null;
    changedFields?: string[] | null;
    aiPremiumEnabled?: boolean | null;
    idempotencyKey?: string | null;
    redactions?: AgentRuntimeCrmEventRedactions | null;

    [key: string]: any;

    constructor(data?: IAgentRuntimeCrmEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.schemaVersion = _data["schemaVersion"] !== undefined ? _data["schemaVersion"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.carrierCompanyId = _data["carrierCompanyId"] !== undefined ? _data["carrierCompanyId"] : null as any;
            this.entityName = _data["entityName"] !== undefined ? _data["entityName"] : null as any;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.actorUserId = _data["actorUserId"] !== undefined ? _data["actorUserId"] : null as any;
            if (Array.isArray(_data["changedFields"])) {
                this.changedFields = [] as any;
                for (let item of _data["changedFields"])
                    this.changedFields!.push(item);
            }
            else {
                this.changedFields = null as any;
            }
            this.aiPremiumEnabled = _data["aiPremiumEnabled"] !== undefined ? _data["aiPremiumEnabled"] : null as any;
            this.idempotencyKey = _data["idempotencyKey"] !== undefined ? _data["idempotencyKey"] : null as any;
            this.redactions = _data["redactions"] ? AgentRuntimeCrmEventRedactions.fromJS(_data["redactions"]) : null as any;
        }
    }

    static fromJS(data: any): AgentRuntimeCrmEventData {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRuntimeCrmEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["schemaVersion"] = this.schemaVersion !== undefined ? this.schemaVersion : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["carrierCompanyId"] = this.carrierCompanyId !== undefined ? this.carrierCompanyId : null as any;
        data["entityName"] = this.entityName !== undefined ? this.entityName : null as any;
        data["entityId"] = this.entityId !== undefined ? this.entityId : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["actorUserId"] = this.actorUserId !== undefined ? this.actorUserId : null as any;
        if (Array.isArray(this.changedFields)) {
            data["changedFields"] = [];
            for (let item of this.changedFields)
                data["changedFields"].push(item);
        }
        data["aiPremiumEnabled"] = this.aiPremiumEnabled !== undefined ? this.aiPremiumEnabled : null as any;
        data["idempotencyKey"] = this.idempotencyKey !== undefined ? this.idempotencyKey : null as any;
        data["redactions"] = this.redactions ? this.redactions.toJSON() : null as any;
        return data;
    }
}

export interface IAgentRuntimeCrmEventData {
    schemaVersion?: string | null;
    customerId?: number;
    claimId?: number | null;
    carrierCompanyId?: number | null;
    entityName?: string | null;
    entityId?: number;
    operation?: string | null;
    actorUserId?: number | null;
    changedFields?: string[] | null;
    aiPremiumEnabled?: boolean | null;
    idempotencyKey?: string | null;
    redactions?: AgentRuntimeCrmEventRedactions | null;

    [key: string]: any;
}

export class AgentRuntimeCrmEventRedactions implements IAgentRuntimeCrmEventRedactions {
    actorEmail?: string | null;
    attachmentObjectKey?: string | null;
    rawPayload?: string | null;
    routes?: string | null;

    [key: string]: any;

    constructor(data?: IAgentRuntimeCrmEventRedactions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.actorEmail = _data["actorEmail"] !== undefined ? _data["actorEmail"] : null as any;
            this.attachmentObjectKey = _data["attachmentObjectKey"] !== undefined ? _data["attachmentObjectKey"] : null as any;
            this.rawPayload = _data["rawPayload"] !== undefined ? _data["rawPayload"] : null as any;
            this.routes = _data["routes"] !== undefined ? _data["routes"] : null as any;
        }
    }

    static fromJS(data: any): AgentRuntimeCrmEventRedactions {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRuntimeCrmEventRedactions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["actorEmail"] = this.actorEmail !== undefined ? this.actorEmail : null as any;
        data["attachmentObjectKey"] = this.attachmentObjectKey !== undefined ? this.attachmentObjectKey : null as any;
        data["rawPayload"] = this.rawPayload !== undefined ? this.rawPayload : null as any;
        data["routes"] = this.routes !== undefined ? this.routes : null as any;
        return data;
    }
}

export interface IAgentRuntimeCrmEventRedactions {
    actorEmail?: string | null;
    attachmentObjectKey?: string | null;
    rawPayload?: string | null;
    routes?: string | null;

    [key: string]: any;
}

export class AgentRuntimeCrmEventResult implements IAgentRuntimeCrmEventResult {
    status?: string | null;
    eventId?: string | null;
    source?: string | null;
    agentType?: string | null;
    agentName?: string | null;
    classification?: string | null;
    processingStatus?: string | null;

    [key: string]: any;

    constructor(data?: IAgentRuntimeCrmEventResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.agentType = _data["agentType"] !== undefined ? _data["agentType"] : null as any;
            this.agentName = _data["agentName"] !== undefined ? _data["agentName"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            this.processingStatus = _data["processingStatus"] !== undefined ? _data["processingStatus"] : null as any;
        }
    }

    static fromJS(data: any): AgentRuntimeCrmEventResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRuntimeCrmEventResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["eventId"] = this.eventId !== undefined ? this.eventId : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["agentType"] = this.agentType !== undefined ? this.agentType : null as any;
        data["agentName"] = this.agentName !== undefined ? this.agentName : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : null as any;
        return data;
    }
}

export interface IAgentRuntimeCrmEventResult {
    status?: string | null;
    eventId?: string | null;
    source?: string | null;
    agentType?: string | null;
    agentName?: string | null;
    classification?: string | null;
    processingStatus?: string | null;

    [key: string]: any;
}

export class AgentRuntimeCrmEventRoute implements IAgentRuntimeCrmEventRoute {
    agentType?: string | null;
    agentName?: string | null;
    reason?: string | null;

    [key: string]: any;

    constructor(data?: IAgentRuntimeCrmEventRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agentType = _data["agentType"] !== undefined ? _data["agentType"] : null as any;
            this.agentName = _data["agentName"] !== undefined ? _data["agentName"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static fromJS(data: any): AgentRuntimeCrmEventRoute {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRuntimeCrmEventRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agentType"] = this.agentType !== undefined ? this.agentType : null as any;
        data["agentName"] = this.agentName !== undefined ? this.agentName : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        return data;
    }
}

export interface IAgentRuntimeCrmEventRoute {
    agentType?: string | null;
    agentName?: string | null;
    reason?: string | null;

    [key: string]: any;
}

export class AgentTaskBatchCreateRequest implements IAgentTaskBatchCreateRequest {
    approvalId?: string | null;
    source?: string | null;
    tasks?: ClaimAgentTaskChecklistItemDto[];

    [key: string]: any;

    constructor(data?: IAgentTaskBatchCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ClaimAgentTaskChecklistItemDto.fromJS(item));
            }
            else {
                this.tasks = null as any;
            }
        }
    }

    static fromJS(data: any): AgentTaskBatchCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskBatchCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentTaskBatchCreateRequest {
    approvalId?: string | null;
    source?: string | null;
    tasks?: ClaimAgentTaskChecklistItemDto[];

    [key: string]: any;
}

export class AgentTaskBatchCreateResponse implements IAgentTaskBatchCreateResponse {
    approvalId?: string | null;
    requestedCount?: number;
    createdTasks?: AgentTaskDto[];

    [key: string]: any;

    constructor(data?: IAgentTaskBatchCreateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.requestedCount = _data["requestedCount"] !== undefined ? _data["requestedCount"] : null as any;
            if (Array.isArray(_data["createdTasks"])) {
                this.createdTasks = [] as any;
                for (let item of _data["createdTasks"])
                    this.createdTasks!.push(AgentTaskDto.fromJS(item));
            }
            else {
                this.createdTasks = null as any;
            }
        }
    }

    static fromJS(data: any): AgentTaskBatchCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskBatchCreateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["requestedCount"] = this.requestedCount !== undefined ? this.requestedCount : null as any;
        if (Array.isArray(this.createdTasks)) {
            data["createdTasks"] = [];
            for (let item of this.createdTasks)
                data["createdTasks"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAgentTaskBatchCreateResponse {
    approvalId?: string | null;
    requestedCount?: number;
    createdTasks?: AgentTaskDto[];

    [key: string]: any;
}

export class AgentTaskDto implements IAgentTaskDto {
    id?: number | null;
    title?: string;
    priority?: PriorityEnum;
    dueDate?: DateTime;
    completedDate?: DateTime | null;
    status?: TaskStatusEnum;
    rowVersion?: string;
    description?: string;
    notes?: string;
    userId?: number;
    goalId?: number | null;
    goalTitle?: string | null;
    parentTaskId?: number | null;
    parentTaskTitle?: string | null;
    participants?: AgentTaskParticipantDto[];
    claimId?: number | null;
    leadId?: number | null;
    claimNumber?: string;
    leadContact?: string;

    [key: string]: any;

    constructor(data?: IAgentTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : null as any;
            this.completedDate = _data["completedDate"] ? DateTime.fromISO(_data["completedDate"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.rowVersion = _data["rowVersion"] !== undefined ? _data["rowVersion"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.goalId = _data["goalId"] !== undefined ? _data["goalId"] : null as any;
            this.goalTitle = _data["goalTitle"] !== undefined ? _data["goalTitle"] : null as any;
            this.parentTaskId = _data["parentTaskId"] !== undefined ? _data["parentTaskId"] : null as any;
            this.parentTaskTitle = _data["parentTaskTitle"] !== undefined ? _data["parentTaskTitle"] : null as any;
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(AgentTaskParticipantDto.fromJS(item));
            }
            else {
                this.participants = null as any;
            }
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.leadId = _data["leadId"] !== undefined ? _data["leadId"] : null as any;
            this.claimNumber = _data["claimNumber"] !== undefined ? _data["claimNumber"] : null as any;
            this.leadContact = _data["leadContact"] !== undefined ? _data["leadContact"] : null as any;
        }
    }

    static fromJS(data: any): AgentTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : null as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["rowVersion"] = this.rowVersion !== undefined ? this.rowVersion : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["goalId"] = this.goalId !== undefined ? this.goalId : null as any;
        data["goalTitle"] = this.goalTitle !== undefined ? this.goalTitle : null as any;
        data["parentTaskId"] = this.parentTaskId !== undefined ? this.parentTaskId : null as any;
        data["parentTaskTitle"] = this.parentTaskTitle !== undefined ? this.parentTaskTitle : null as any;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item ? item.toJSON() : null as any);
        }
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["leadId"] = this.leadId !== undefined ? this.leadId : null as any;
        data["claimNumber"] = this.claimNumber !== undefined ? this.claimNumber : null as any;
        data["leadContact"] = this.leadContact !== undefined ? this.leadContact : null as any;
        return data;
    }
}

export interface IAgentTaskDto {
    id?: number | null;
    title?: string;
    priority?: PriorityEnum;
    dueDate?: DateTime;
    completedDate?: DateTime | null;
    status?: TaskStatusEnum;
    rowVersion?: string;
    description?: string;
    notes?: string;
    userId?: number;
    goalId?: number | null;
    goalTitle?: string | null;
    parentTaskId?: number | null;
    parentTaskTitle?: string | null;
    participants?: AgentTaskParticipantDto[];
    claimId?: number | null;
    leadId?: number | null;
    claimNumber?: string;
    leadContact?: string;

    [key: string]: any;
}

export class AgentTaskParticipantDto implements IAgentTaskParticipantDto {
    userId?: number;
    role?: TaskParticipantRoleEnum;
    name?: string | null;

    [key: string]: any;

    constructor(data?: IAgentTaskParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): AgentTaskParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IAgentTaskParticipantDto {
    userId?: number;
    role?: TaskParticipantRoleEnum;
    name?: string | null;

    [key: string]: any;
}

export class AttachmentFileDto implements IAttachmentFileDto {
    id?: number | null;
    container?: BlobContainerEnum;
    attachmentType?: string;
    referenceId?: number;
    fileName?: string;
    label?: string | null;
    blobPath?: string;
    size?: number;
    extension?: string | null;
    thumbnail?: string;
    folderId?: number | null;
    description?: string | null;
    createdBy?: string;
    createdWhen?: DateTime;
    updatedWhen?: DateTime;
    folder?: AttachmentFolderNameDto;
    signedLocation?: string;

    [key: string]: any;

    constructor(data?: IAttachmentFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.container = _data["container"] !== undefined ? _data["container"] : null as any;
            this.attachmentType = _data["attachmentType"] !== undefined ? _data["attachmentType"] : null as any;
            this.referenceId = _data["referenceId"] !== undefined ? _data["referenceId"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.blobPath = _data["blobPath"] !== undefined ? _data["blobPath"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.extension = _data["extension"] !== undefined ? _data["extension"] : null as any;
            this.thumbnail = _data["thumbnail"] !== undefined ? _data["thumbnail"] : null as any;
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.createdWhen = _data["createdWhen"] ? DateTime.fromISO(_data["createdWhen"].toString()) : null as any;
            this.updatedWhen = _data["updatedWhen"] ? DateTime.fromISO(_data["updatedWhen"].toString()) : null as any;
            this.folder = _data["folder"] ? AttachmentFolderNameDto.fromJS(_data["folder"]) : null as any;
            this.signedLocation = _data["signedLocation"] !== undefined ? _data["signedLocation"] : null as any;
        }
    }

    static fromJS(data: any): AttachmentFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["container"] = this.container !== undefined ? this.container : null as any;
        data["attachmentType"] = this.attachmentType !== undefined ? this.attachmentType : null as any;
        data["referenceId"] = this.referenceId !== undefined ? this.referenceId : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["blobPath"] = this.blobPath !== undefined ? this.blobPath : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["extension"] = this.extension !== undefined ? this.extension : null as any;
        data["thumbnail"] = this.thumbnail !== undefined ? this.thumbnail : null as any;
        data["folderId"] = this.folderId !== undefined ? this.folderId : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toString() : null as any;
        data["updatedWhen"] = this.updatedWhen ? this.updatedWhen.toString() : null as any;
        data["folder"] = this.folder ? this.folder.toJSON() : null as any;
        data["signedLocation"] = this.signedLocation !== undefined ? this.signedLocation : null as any;
        return data;
    }
}

export interface IAttachmentFileDto {
    id?: number | null;
    container?: BlobContainerEnum;
    attachmentType?: string;
    referenceId?: number;
    fileName?: string;
    label?: string | null;
    blobPath?: string;
    size?: number;
    extension?: string | null;
    thumbnail?: string;
    folderId?: number | null;
    description?: string | null;
    createdBy?: string;
    createdWhen?: DateTime;
    updatedWhen?: DateTime;
    folder?: AttachmentFolderNameDto;
    signedLocation?: string;

    [key: string]: any;
}

export class AttachmentFolderNameDto implements IAttachmentFolderNameDto {
    id?: number | null;
    name?: string;

    [key: string]: any;

    constructor(data?: IAttachmentFolderNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): AttachmentFolderNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentFolderNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IAttachmentFolderNameDto {
    id?: number | null;
    name?: string;

    [key: string]: any;
}

export enum BlobContainerEnum {
    Claims = "Claims",
    ProfilePictures = "ProfilePictures",
    Leads = "Leads",
    DocumentTemplates = "DocumentTemplates",
    Companies = "Companies",
    Logos = "Logos",
    Contacts = "Contacts",
    Migration = "Migration",
    NotificationImages = "NotificationImages",
    DocumentRecognition = "DocumentRecognition",
    CompanyFiles = "CompanyFiles",
    TemporaryFiles = "TemporaryFiles",
    PhotoReports = "PhotoReports",
    TaskFiles = "TaskFiles",
    TeamChat = "TeamChat",
}

export class ClaimAgentConversationAttachmentDto implements IClaimAgentConversationAttachmentDto {
    source?: string;
    id?: string;
    displayName?: string;
    mediaType?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: IClaimAgentConversationAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.mediaType = _data["mediaType"] !== undefined ? _data["mediaType"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentConversationAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentConversationAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["mediaType"] = this.mediaType !== undefined ? this.mediaType : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        return data;
    }
}

export interface IClaimAgentConversationAttachmentDto {
    source?: string;
    id?: string;
    displayName?: string;
    mediaType?: string;
    size?: number;

    [key: string]: any;
}

export class ClaimAgentConversationMessageDto implements IClaimAgentConversationMessageDto {
    id?: string;
    role?: string;
    content?: any;
    name?: string | null;
    toolCalls?: any;
    toolCallId?: string | null;
    attachments?: ClaimAgentConversationAttachmentDto[] | null;

    [key: string]: any;

    constructor(data?: IClaimAgentConversationMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.toolCalls = _data["toolCalls"] !== undefined ? _data["toolCalls"] : null as any;
            this.toolCallId = _data["toolCallId"] !== undefined ? _data["toolCallId"] : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ClaimAgentConversationAttachmentDto.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
        }
    }

    static fromJS(data: any): ClaimAgentConversationMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentConversationMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["toolCalls"] = this.toolCalls !== undefined ? this.toolCalls : null as any;
        data["toolCallId"] = this.toolCallId !== undefined ? this.toolCallId : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IClaimAgentConversationMessageDto {
    id?: string;
    role?: string;
    content?: any;
    name?: string | null;
    toolCalls?: any;
    toolCallId?: string | null;
    attachments?: ClaimAgentConversationAttachmentDto[] | null;

    [key: string]: any;
}

export class ClaimAgentConversationResponse implements IClaimAgentConversationResponse {
    threadId?: string;
    messages?: ClaimAgentConversationMessageDto[];
    state?: any;

    [key: string]: any;

    constructor(data?: IClaimAgentConversationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.threadId = _data["threadId"] !== undefined ? _data["threadId"] : null as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ClaimAgentConversationMessageDto.fromJS(item));
            }
            else {
                this.messages = null as any;
            }
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentConversationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentConversationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["threadId"] = this.threadId !== undefined ? this.threadId : null as any;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : null as any);
        }
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IClaimAgentConversationResponse {
    threadId?: string;
    messages?: ClaimAgentConversationMessageDto[];
    state?: any;

    [key: string]: any;
}

export class ClaimAgentDeveloperInfoResponse implements IClaimAgentDeveloperInfoResponse {
    tools?: ClaimAgentDeveloperToolDto[];

    [key: string]: any;

    constructor(data?: IClaimAgentDeveloperInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["tools"])) {
                this.tools = [] as any;
                for (let item of _data["tools"])
                    this.tools!.push(ClaimAgentDeveloperToolDto.fromJS(item));
            }
            else {
                this.tools = null as any;
            }
        }
    }

    static fromJS(data: any): ClaimAgentDeveloperInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentDeveloperInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.tools)) {
            data["tools"] = [];
            for (let item of this.tools)
                data["tools"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IClaimAgentDeveloperInfoResponse {
    tools?: ClaimAgentDeveloperToolDto[];

    [key: string]: any;
}

export class ClaimAgentDeveloperToolDto implements IClaimAgentDeveloperToolDto {
    name?: string;
    title?: string;
    description?: string;
    source?: string;
    readOnly?: boolean;

    [key: string]: any;

    constructor(data?: IClaimAgentDeveloperToolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.readOnly = _data["readOnly"] !== undefined ? _data["readOnly"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentDeveloperToolDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentDeveloperToolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["readOnly"] = this.readOnly !== undefined ? this.readOnly : null as any;
        return data;
    }
}

export interface IClaimAgentDeveloperToolDto {
    name?: string;
    title?: string;
    description?: string;
    source?: string;
    readOnly?: boolean;

    [key: string]: any;
}

export class ClaimAgentDocumentGenerateRequest implements IClaimAgentDocumentGenerateRequest {
    approvalId?: string | null;
    source?: string | null;
    templateId?: number;

    [key: string]: any;

    constructor(data?: IClaimAgentDocumentGenerateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentDocumentGenerateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentDocumentGenerateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["templateId"] = this.templateId !== undefined ? this.templateId : null as any;
        return data;
    }
}

export interface IClaimAgentDocumentGenerateRequest {
    approvalId?: string | null;
    source?: string | null;
    templateId?: number;

    [key: string]: any;
}

export class ClaimAgentDocumentGenerateResponse implements IClaimAgentDocumentGenerateResponse {
    approvalId?: string | null;
    templateId?: number;
    url?: string;
    fileType?: string;

    [key: string]: any;

    constructor(data?: IClaimAgentDocumentGenerateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.approvalId = _data["approvalId"] !== undefined ? _data["approvalId"] : null as any;
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentDocumentGenerateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentDocumentGenerateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["approvalId"] = this.approvalId !== undefined ? this.approvalId : null as any;
        data["templateId"] = this.templateId !== undefined ? this.templateId : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        return data;
    }
}

export interface IClaimAgentDocumentGenerateResponse {
    approvalId?: string | null;
    templateId?: number;
    url?: string;
    fileType?: string;

    [key: string]: any;
}

export class ClaimAgentDocumentPreviewRequest implements IClaimAgentDocumentPreviewRequest {
    templateId?: number;

    [key: string]: any;

    constructor(data?: IClaimAgentDocumentPreviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentDocumentPreviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentDocumentPreviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["templateId"] = this.templateId !== undefined ? this.templateId : null as any;
        return data;
    }
}

export interface IClaimAgentDocumentPreviewRequest {
    templateId?: number;

    [key: string]: any;
}

export class ClaimAgentDocumentPreviewResponse implements IClaimAgentDocumentPreviewResponse {
    templateId?: number;
    url?: string;
    fileType?: string;

    [key: string]: any;

    constructor(data?: IClaimAgentDocumentPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentDocumentPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentDocumentPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["templateId"] = this.templateId !== undefined ? this.templateId : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        return data;
    }
}

export interface IClaimAgentDocumentPreviewResponse {
    templateId?: number;
    url?: string;
    fileType?: string;

    [key: string]: any;
}

export enum ClaimAgentRecommendationAction {
    Review = "Review",
    DraftReply = "DraftReply",
    PrepareTask = "PrepareTask",
    DraftUpdate = "DraftUpdate",
}

export class ClaimAgentRecommendationActivityDto implements IClaimAgentRecommendationActivityDto {
    activityType?: string;
    authorName?: string;
    isPinned?: boolean;

    [key: string]: any;

    constructor(data?: IClaimAgentRecommendationActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.activityType = _data["activityType"] !== undefined ? _data["activityType"] : null as any;
            this.authorName = _data["authorName"] !== undefined ? _data["authorName"] : null as any;
            this.isPinned = _data["isPinned"] !== undefined ? _data["isPinned"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentRecommendationActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentRecommendationActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["activityType"] = this.activityType !== undefined ? this.activityType : null as any;
        data["authorName"] = this.authorName !== undefined ? this.authorName : null as any;
        data["isPinned"] = this.isPinned !== undefined ? this.isPinned : null as any;
        return data;
    }
}

export interface IClaimAgentRecommendationActivityDto {
    activityType?: string;
    authorName?: string;
    isPinned?: boolean;

    [key: string]: any;
}

export class ClaimAgentRecommendationDto implements IClaimAgentRecommendationDto {
    id?: string;
    action?: ClaimAgentRecommendationAction;
    title?: string;
    reason?: string;
    prompt?: string;
    sourceLabel?: string;
    sourceKind?: string;
    sourceTime?: DateTime;
    email?: ClaimAgentRecommendationEmailDto | null;
    task?: ClaimAgentRecommendationTaskDto | null;
    activity?: ClaimAgentRecommendationActivityDto | null;
    file?: ClaimAgentRecommendationFileDto | null;

    [key: string]: any;

    constructor(data?: IClaimAgentRecommendationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.prompt = _data["prompt"] !== undefined ? _data["prompt"] : null as any;
            this.sourceLabel = _data["sourceLabel"] !== undefined ? _data["sourceLabel"] : null as any;
            this.sourceKind = _data["sourceKind"] !== undefined ? _data["sourceKind"] : null as any;
            this.sourceTime = _data["sourceTime"] ? DateTime.fromISO(_data["sourceTime"].toString()) : null as any;
            this.email = _data["email"] ? ClaimAgentRecommendationEmailDto.fromJS(_data["email"]) : null as any;
            this.task = _data["task"] ? ClaimAgentRecommendationTaskDto.fromJS(_data["task"]) : null as any;
            this.activity = _data["activity"] ? ClaimAgentRecommendationActivityDto.fromJS(_data["activity"]) : null as any;
            this.file = _data["file"] ? ClaimAgentRecommendationFileDto.fromJS(_data["file"]) : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentRecommendationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentRecommendationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["prompt"] = this.prompt !== undefined ? this.prompt : null as any;
        data["sourceLabel"] = this.sourceLabel !== undefined ? this.sourceLabel : null as any;
        data["sourceKind"] = this.sourceKind !== undefined ? this.sourceKind : null as any;
        data["sourceTime"] = this.sourceTime ? this.sourceTime.toString() : null as any;
        data["email"] = this.email ? this.email.toJSON() : null as any;
        data["task"] = this.task ? this.task.toJSON() : null as any;
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        return data;
    }
}

export interface IClaimAgentRecommendationDto {
    id?: string;
    action?: ClaimAgentRecommendationAction;
    title?: string;
    reason?: string;
    prompt?: string;
    sourceLabel?: string;
    sourceKind?: string;
    sourceTime?: DateTime;
    email?: ClaimAgentRecommendationEmailDto | null;
    task?: ClaimAgentRecommendationTaskDto | null;
    activity?: ClaimAgentRecommendationActivityDto | null;
    file?: ClaimAgentRecommendationFileDto | null;

    [key: string]: any;
}

export class ClaimAgentRecommendationEmailDto implements IClaimAgentRecommendationEmailDto {
    senderName?: string;
    attachmentCount?: number;

    [key: string]: any;

    constructor(data?: IClaimAgentRecommendationEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.senderName = _data["senderName"] !== undefined ? _data["senderName"] : null as any;
            this.attachmentCount = _data["attachmentCount"] !== undefined ? _data["attachmentCount"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentRecommendationEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentRecommendationEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["senderName"] = this.senderName !== undefined ? this.senderName : null as any;
        data["attachmentCount"] = this.attachmentCount !== undefined ? this.attachmentCount : null as any;
        return data;
    }
}

export interface IClaimAgentRecommendationEmailDto {
    senderName?: string;
    attachmentCount?: number;

    [key: string]: any;
}

export class ClaimAgentRecommendationFeedbackRequest implements IClaimAgentRecommendationFeedbackRequest {
    snooze?: boolean;

    [key: string]: any;

    constructor(data?: IClaimAgentRecommendationFeedbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.snooze = _data["snooze"] !== undefined ? _data["snooze"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentRecommendationFeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentRecommendationFeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["snooze"] = this.snooze !== undefined ? this.snooze : null as any;
        return data;
    }
}

export interface IClaimAgentRecommendationFeedbackRequest {
    snooze?: boolean;

    [key: string]: any;
}

export class ClaimAgentRecommendationFileDto implements IClaimAgentRecommendationFileDto {
    fileName?: string;
    contentType?: string;
    size?: number;
    documentKind?: string | null;
    summary?: string | null;
    importance?: string | null;
    claimRelevance?: string | null;

    [key: string]: any;

    constructor(data?: IClaimAgentRecommendationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.documentKind = _data["documentKind"] !== undefined ? _data["documentKind"] : null as any;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
            this.importance = _data["importance"] !== undefined ? _data["importance"] : null as any;
            this.claimRelevance = _data["claimRelevance"] !== undefined ? _data["claimRelevance"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentRecommendationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentRecommendationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["documentKind"] = this.documentKind !== undefined ? this.documentKind : null as any;
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        data["importance"] = this.importance !== undefined ? this.importance : null as any;
        data["claimRelevance"] = this.claimRelevance !== undefined ? this.claimRelevance : null as any;
        return data;
    }
}

export interface IClaimAgentRecommendationFileDto {
    fileName?: string;
    contentType?: string;
    size?: number;
    documentKind?: string | null;
    summary?: string | null;
    importance?: string | null;
    claimRelevance?: string | null;

    [key: string]: any;
}

export class ClaimAgentRecommendationSelectionRequest implements IClaimAgentRecommendationSelectionRequest {
    revision?: string;

    [key: string]: any;

    constructor(data?: IClaimAgentRecommendationSelectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.revision = _data["revision"] !== undefined ? _data["revision"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentRecommendationSelectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentRecommendationSelectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["revision"] = this.revision !== undefined ? this.revision : null as any;
        return data;
    }
}

export interface IClaimAgentRecommendationSelectionRequest {
    revision?: string;

    [key: string]: any;
}

export class ClaimAgentRecommendationSetDto implements IClaimAgentRecommendationSetDto {
    enabled?: boolean;
    revision?: string;
    expiresAt?: DateTime;
    items?: ClaimAgentRecommendationDto[];

    [key: string]: any;

    constructor(data?: IClaimAgentRecommendationSetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.revision = _data["revision"] !== undefined ? _data["revision"] : null as any;
            this.expiresAt = _data["expiresAt"] ? DateTime.fromISO(_data["expiresAt"].toString()) : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClaimAgentRecommendationDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): ClaimAgentRecommendationSetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentRecommendationSetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["revision"] = this.revision !== undefined ? this.revision : null as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toString() : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IClaimAgentRecommendationSetDto {
    enabled?: boolean;
    revision?: string;
    expiresAt?: DateTime;
    items?: ClaimAgentRecommendationDto[];

    [key: string]: any;
}

export class ClaimAgentRecommendationTaskDto implements IClaimAgentRecommendationTaskDto {
    status?: TaskStatusEnum;
    priority?: PriorityEnum;
    dueAt?: DateTime | null;
    assigneeName?: string;
    assignedToMe?: boolean;

    [key: string]: any;

    constructor(data?: IClaimAgentRecommendationTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.dueAt = _data["dueAt"] ? DateTime.fromISO(_data["dueAt"].toString()) : null as any;
            this.assigneeName = _data["assigneeName"] !== undefined ? _data["assigneeName"] : null as any;
            this.assignedToMe = _data["assignedToMe"] !== undefined ? _data["assignedToMe"] : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentRecommendationTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentRecommendationTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["dueAt"] = this.dueAt ? this.dueAt.toString() : null as any;
        data["assigneeName"] = this.assigneeName !== undefined ? this.assigneeName : null as any;
        data["assignedToMe"] = this.assignedToMe !== undefined ? this.assignedToMe : null as any;
        return data;
    }
}

export interface IClaimAgentRecommendationTaskDto {
    status?: TaskStatusEnum;
    priority?: PriorityEnum;
    dueAt?: DateTime | null;
    assigneeName?: string;
    assignedToMe?: boolean;

    [key: string]: any;
}

export class ClaimAgentTaskChecklistItemDto implements IClaimAgentTaskChecklistItemDto {
    clientItemId?: string;
    title?: string;
    description?: string | null;
    notes?: string | null;
    priority?: PriorityEnum;
    dueDate?: DateTime | null;
    userId?: number | null;
    claimId?: number | null;
    leadId?: number | null;
    goalId?: number | null;
    parentTaskId?: number | null;
    collaboratorUserIds?: number[];
    watcherUserIds?: number[];

    [key: string]: any;

    constructor(data?: IClaimAgentTaskChecklistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientItemId = _data["clientItemId"] !== undefined ? _data["clientItemId"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.leadId = _data["leadId"] !== undefined ? _data["leadId"] : null as any;
            this.goalId = _data["goalId"] !== undefined ? _data["goalId"] : null as any;
            this.parentTaskId = _data["parentTaskId"] !== undefined ? _data["parentTaskId"] : null as any;
            if (Array.isArray(_data["collaboratorUserIds"])) {
                this.collaboratorUserIds = [] as any;
                for (let item of _data["collaboratorUserIds"])
                    this.collaboratorUserIds!.push(item);
            }
            else {
                this.collaboratorUserIds = null as any;
            }
            if (Array.isArray(_data["watcherUserIds"])) {
                this.watcherUserIds = [] as any;
                for (let item of _data["watcherUserIds"])
                    this.watcherUserIds!.push(item);
            }
            else {
                this.watcherUserIds = null as any;
            }
        }
    }

    static fromJS(data: any): ClaimAgentTaskChecklistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentTaskChecklistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientItemId"] = this.clientItemId !== undefined ? this.clientItemId : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["leadId"] = this.leadId !== undefined ? this.leadId : null as any;
        data["goalId"] = this.goalId !== undefined ? this.goalId : null as any;
        data["parentTaskId"] = this.parentTaskId !== undefined ? this.parentTaskId : null as any;
        if (Array.isArray(this.collaboratorUserIds)) {
            data["collaboratorUserIds"] = [];
            for (let item of this.collaboratorUserIds)
                data["collaboratorUserIds"].push(item);
        }
        if (Array.isArray(this.watcherUserIds)) {
            data["watcherUserIds"] = [];
            for (let item of this.watcherUserIds)
                data["watcherUserIds"].push(item);
        }
        return data;
    }
}

export interface IClaimAgentTaskChecklistItemDto {
    clientItemId?: string;
    title?: string;
    description?: string | null;
    notes?: string | null;
    priority?: PriorityEnum;
    dueDate?: DateTime | null;
    userId?: number | null;
    claimId?: number | null;
    leadId?: number | null;
    goalId?: number | null;
    parentTaskId?: number | null;
    collaboratorUserIds?: number[];
    watcherUserIds?: number[];

    [key: string]: any;
}

export class ClaimAgentTemporaryUploadResponse implements IClaimAgentTemporaryUploadResponse {
    source!: string;
    id!: string;
    displayName!: string;
    fileName!: string;
    mimeType!: string;
    size!: number;
    expiresAtUtc!: DateTime;

    [key: string]: any;

    constructor(data?: IClaimAgentTemporaryUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.expiresAtUtc = _data["expiresAtUtc"] ? DateTime.fromISO(_data["expiresAtUtc"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ClaimAgentTemporaryUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAgentTemporaryUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toString() : null as any;
        return data;
    }
}

export interface IClaimAgentTemporaryUploadResponse {
    source: string;
    id: string;
    displayName: string;
    fileName: string;
    mimeType: string;
    size: number;
    expiresAtUtc: DateTime;

    [key: string]: any;
}

export class ClaimContactCardDto implements IClaimContactCardDto {
    id?: number;
    claimId?: number | null;
    claimContactId?: number | null;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    imageBlobPath?: string | null;
    contactType?: string | null;
    isUser?: boolean | null;
    userId?: number | null;
    userType?: UserType | null;
    defaultCommissionType?: DefaultCommissionType | null;
    defaultCommissionAmount?: number | null;
    fullName?: string | null;
    contactSection?: ContactSectionsEnum;
    claimRoleTags?: ClaimRoleTagsDto[];

    [key: string]: any;

    constructor(data?: IClaimContactCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.claimContactId = _data["claimContactId"] !== undefined ? _data["claimContactId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.imageBlobPath = _data["imageBlobPath"] !== undefined ? _data["imageBlobPath"] : null as any;
            this.contactType = _data["contactType"] !== undefined ? _data["contactType"] : null as any;
            this.isUser = _data["isUser"] !== undefined ? _data["isUser"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : null as any;
            this.defaultCommissionType = _data["defaultCommissionType"] !== undefined ? _data["defaultCommissionType"] : null as any;
            this.defaultCommissionAmount = _data["defaultCommissionAmount"] !== undefined ? _data["defaultCommissionAmount"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.contactSection = _data["contactSection"] !== undefined ? _data["contactSection"] : null as any;
            if (Array.isArray(_data["claimRoleTags"])) {
                this.claimRoleTags = [] as any;
                for (let item of _data["claimRoleTags"])
                    this.claimRoleTags!.push(ClaimRoleTagsDto.fromJS(item));
            }
            else {
                this.claimRoleTags = null as any;
            }
        }
    }

    static fromJS(data: any): ClaimContactCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimContactCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["claimContactId"] = this.claimContactId !== undefined ? this.claimContactId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["imageBlobPath"] = this.imageBlobPath !== undefined ? this.imageBlobPath : null as any;
        data["contactType"] = this.contactType !== undefined ? this.contactType : null as any;
        data["isUser"] = this.isUser !== undefined ? this.isUser : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userType"] = this.userType !== undefined ? this.userType : null as any;
        data["defaultCommissionType"] = this.defaultCommissionType !== undefined ? this.defaultCommissionType : null as any;
        data["defaultCommissionAmount"] = this.defaultCommissionAmount !== undefined ? this.defaultCommissionAmount : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["contactSection"] = this.contactSection !== undefined ? this.contactSection : null as any;
        if (Array.isArray(this.claimRoleTags)) {
            data["claimRoleTags"] = [];
            for (let item of this.claimRoleTags)
                data["claimRoleTags"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IClaimContactCardDto {
    id?: number;
    claimId?: number | null;
    claimContactId?: number | null;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    imageBlobPath?: string | null;
    contactType?: string | null;
    isUser?: boolean | null;
    userId?: number | null;
    userType?: UserType | null;
    defaultCommissionType?: DefaultCommissionType | null;
    defaultCommissionAmount?: number | null;
    fullName?: string | null;
    contactSection?: ContactSectionsEnum;
    claimRoleTags?: ClaimRoleTagsDto[];

    [key: string]: any;
}

export class ClaimRoleTagsDto implements IClaimRoleTagsDto {
    id?: number | null;
    name?: string;
    order?: number;
    color?: string | null;
    textColor?: string | null;

    [key: string]: any;

    constructor(data?: IClaimRoleTagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.color = _data["color"] !== undefined ? _data["color"] : null as any;
            this.textColor = _data["textColor"] !== undefined ? _data["textColor"] : null as any;
        }
    }

    static fromJS(data: any): ClaimRoleTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimRoleTagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["color"] = this.color !== undefined ? this.color : null as any;
        data["textColor"] = this.textColor !== undefined ? this.textColor : null as any;
        return data;
    }
}

export interface IClaimRoleTagsDto {
    id?: number | null;
    name?: string;
    order?: number;
    color?: string | null;
    textColor?: string | null;

    [key: string]: any;
}

export class ClaimStatusListDto implements IClaimStatusListDto {
    id!: number;
    name?: string;
    order!: number;
    description?: string;
    color?: string | null;
    textColor?: string | null;
    isClosed?: boolean | null;
    claims?: number | null;

    [key: string]: any;

    constructor(data?: IClaimStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.color = _data["color"] !== undefined ? _data["color"] : null as any;
            this.textColor = _data["textColor"] !== undefined ? _data["textColor"] : null as any;
            this.isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : null as any;
            this.claims = _data["claims"] !== undefined ? _data["claims"] : null as any;
        }
    }

    static fromJS(data: any): ClaimStatusListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["color"] = this.color !== undefined ? this.color : null as any;
        data["textColor"] = this.textColor !== undefined ? this.textColor : null as any;
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : null as any;
        data["claims"] = this.claims !== undefined ? this.claims : null as any;
        return data;
    }
}

export interface IClaimStatusListDto {
    id: number;
    name?: string;
    order: number;
    description?: string;
    color?: string | null;
    textColor?: string | null;
    isClosed?: boolean | null;
    claims?: number | null;

    [key: string]: any;
}

export class ClaimTimeLoggedDto implements IClaimTimeLoggedDto {
    hours?: number;
    minutes?: number;

    [key: string]: any;

    constructor(data?: IClaimTimeLoggedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.hours = _data["hours"] !== undefined ? _data["hours"] : null as any;
            this.minutes = _data["minutes"] !== undefined ? _data["minutes"] : null as any;
        }
    }

    static fromJS(data: any): ClaimTimeLoggedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTimeLoggedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["hours"] = this.hours !== undefined ? this.hours : null as any;
        data["minutes"] = this.minutes !== undefined ? this.minutes : null as any;
        return data;
    }
}

export interface IClaimTimeLoggedDto {
    hours?: number;
    minutes?: number;

    [key: string]: any;
}

export class ClaimWorkspaceCrmEvent implements IClaimWorkspaceCrmEvent {
    specversion?: string | null;
    id?: string | null;
    source?: string | null;
    type?: string | null;
    subject?: string | null;
    time?: string | null;
    dataschema?: string | null;
    data?: ClaimWorkspaceCrmEventData | null;
    route?: ClaimWorkspaceCrmEventRoute | null;
    receiver?: AgentMosaicReceiverDispatchMetadata | null;

    [key: string]: any;

    constructor(data?: IClaimWorkspaceCrmEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.specversion = _data["specversion"] !== undefined ? _data["specversion"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.time = _data["time"] !== undefined ? _data["time"] : null as any;
            this.dataschema = _data["dataschema"] !== undefined ? _data["dataschema"] : null as any;
            this.data = _data["data"] ? ClaimWorkspaceCrmEventData.fromJS(_data["data"]) : null as any;
            this.route = _data["route"] ? ClaimWorkspaceCrmEventRoute.fromJS(_data["route"]) : null as any;
            this.receiver = _data["receiver"] ? AgentMosaicReceiverDispatchMetadata.fromJS(_data["receiver"]) : null as any;
        }
    }

    static fromJS(data: any): ClaimWorkspaceCrmEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimWorkspaceCrmEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["specversion"] = this.specversion !== undefined ? this.specversion : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["time"] = this.time !== undefined ? this.time : null as any;
        data["dataschema"] = this.dataschema !== undefined ? this.dataschema : null as any;
        data["data"] = this.data ? this.data.toJSON() : null as any;
        data["route"] = this.route ? this.route.toJSON() : null as any;
        data["receiver"] = this.receiver ? this.receiver.toJSON() : null as any;
        return data;
    }
}

export interface IClaimWorkspaceCrmEvent {
    specversion?: string | null;
    id?: string | null;
    source?: string | null;
    type?: string | null;
    subject?: string | null;
    time?: string | null;
    dataschema?: string | null;
    data?: ClaimWorkspaceCrmEventData | null;
    route?: ClaimWorkspaceCrmEventRoute | null;
    receiver?: AgentMosaicReceiverDispatchMetadata | null;

    [key: string]: any;
}

export class ClaimWorkspaceCrmEventData implements IClaimWorkspaceCrmEventData {
    schemaVersion?: string | null;
    customerId?: number;
    claimId?: number;
    carrierCompanyId?: number | null;
    entityName?: string | null;
    entityId?: number;
    operation?: string | null;
    actorUserId?: number | null;
    actorEmail?: string | null;
    changedFields?: string[] | null;
    attachmentObjectKey?: string | null;
    aiPremiumEnabled?: boolean | null;
    idempotencyKey?: string | null;

    [key: string]: any;

    constructor(data?: IClaimWorkspaceCrmEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.schemaVersion = _data["schemaVersion"] !== undefined ? _data["schemaVersion"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.carrierCompanyId = _data["carrierCompanyId"] !== undefined ? _data["carrierCompanyId"] : null as any;
            this.entityName = _data["entityName"] !== undefined ? _data["entityName"] : null as any;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.actorUserId = _data["actorUserId"] !== undefined ? _data["actorUserId"] : null as any;
            this.actorEmail = _data["actorEmail"] !== undefined ? _data["actorEmail"] : null as any;
            if (Array.isArray(_data["changedFields"])) {
                this.changedFields = [] as any;
                for (let item of _data["changedFields"])
                    this.changedFields!.push(item);
            }
            else {
                this.changedFields = null as any;
            }
            this.attachmentObjectKey = _data["attachmentObjectKey"] !== undefined ? _data["attachmentObjectKey"] : null as any;
            this.aiPremiumEnabled = _data["aiPremiumEnabled"] !== undefined ? _data["aiPremiumEnabled"] : null as any;
            this.idempotencyKey = _data["idempotencyKey"] !== undefined ? _data["idempotencyKey"] : null as any;
        }
    }

    static fromJS(data: any): ClaimWorkspaceCrmEventData {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimWorkspaceCrmEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["schemaVersion"] = this.schemaVersion !== undefined ? this.schemaVersion : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["carrierCompanyId"] = this.carrierCompanyId !== undefined ? this.carrierCompanyId : null as any;
        data["entityName"] = this.entityName !== undefined ? this.entityName : null as any;
        data["entityId"] = this.entityId !== undefined ? this.entityId : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["actorUserId"] = this.actorUserId !== undefined ? this.actorUserId : null as any;
        data["actorEmail"] = this.actorEmail !== undefined ? this.actorEmail : null as any;
        if (Array.isArray(this.changedFields)) {
            data["changedFields"] = [];
            for (let item of this.changedFields)
                data["changedFields"].push(item);
        }
        data["attachmentObjectKey"] = this.attachmentObjectKey !== undefined ? this.attachmentObjectKey : null as any;
        data["aiPremiumEnabled"] = this.aiPremiumEnabled !== undefined ? this.aiPremiumEnabled : null as any;
        data["idempotencyKey"] = this.idempotencyKey !== undefined ? this.idempotencyKey : null as any;
        return data;
    }
}

export interface IClaimWorkspaceCrmEventData {
    schemaVersion?: string | null;
    customerId?: number;
    claimId?: number;
    carrierCompanyId?: number | null;
    entityName?: string | null;
    entityId?: number;
    operation?: string | null;
    actorUserId?: number | null;
    actorEmail?: string | null;
    changedFields?: string[] | null;
    attachmentObjectKey?: string | null;
    aiPremiumEnabled?: boolean | null;
    idempotencyKey?: string | null;

    [key: string]: any;
}

export class ClaimWorkspaceCrmEventResult implements IClaimWorkspaceCrmEventResult {
    status?: string | null;
    eventId?: string | null;
    source?: string | null;
    claimAgentName?: string | null;
    classification?: string | null;
    processingStatus?: string | null;

    [key: string]: any;

    constructor(data?: IClaimWorkspaceCrmEventResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.claimAgentName = _data["claimAgentName"] !== undefined ? _data["claimAgentName"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            this.processingStatus = _data["processingStatus"] !== undefined ? _data["processingStatus"] : null as any;
        }
    }

    static fromJS(data: any): ClaimWorkspaceCrmEventResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimWorkspaceCrmEventResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["eventId"] = this.eventId !== undefined ? this.eventId : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["claimAgentName"] = this.claimAgentName !== undefined ? this.claimAgentName : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : null as any;
        return data;
    }
}

export interface IClaimWorkspaceCrmEventResult {
    status?: string | null;
    eventId?: string | null;
    source?: string | null;
    claimAgentName?: string | null;
    classification?: string | null;
    processingStatus?: string | null;

    [key: string]: any;
}

export class ClaimWorkspaceCrmEventRoute implements IClaimWorkspaceCrmEventRoute {
    agentType?: string | null;
    agentName?: string | null;
    reason?: string | null;

    [key: string]: any;

    constructor(data?: IClaimWorkspaceCrmEventRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agentType = _data["agentType"] !== undefined ? _data["agentType"] : null as any;
            this.agentName = _data["agentName"] !== undefined ? _data["agentName"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static fromJS(data: any): ClaimWorkspaceCrmEventRoute {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimWorkspaceCrmEventRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agentType"] = this.agentType !== undefined ? this.agentType : null as any;
        data["agentName"] = this.agentName !== undefined ? this.agentName : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        return data;
    }
}

export interface IClaimWorkspaceCrmEventRoute {
    agentType?: string | null;
    agentName?: string | null;
    reason?: string | null;

    [key: string]: any;
}

export enum CommissionFeeTypeEnum {
    Percent = "Percent",
    FlatFee = "FlatFee",
    Time = "Time",
}

export enum ContactSectionsEnum {
    General = "General",
    Carrier = "Carrier",
    Staff = "Staff",
}

export class CrmEventData implements ICrmEventData {
    schemaVersion?: string | null;
    customerId?: number | null;
    claimId?: number | null;
    carrierCompanyId?: number | null;
    entityName?: string | null;
    entityId?: number;
    operation?: string | null;
    actorUserId?: number | null;
    actorEmail?: string | null;
    changedFields?: string[] | null;
    attachmentObjectKey?: string | null;
    aiPremiumEnabled?: boolean | null;
    idempotencyKey?: string | null;
    routes?: AgentEventRoute[] | null;

    [key: string]: any;

    constructor(data?: ICrmEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.schemaVersion = _data["schemaVersion"] !== undefined ? _data["schemaVersion"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.carrierCompanyId = _data["carrierCompanyId"] !== undefined ? _data["carrierCompanyId"] : null as any;
            this.entityName = _data["entityName"] !== undefined ? _data["entityName"] : null as any;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.actorUserId = _data["actorUserId"] !== undefined ? _data["actorUserId"] : null as any;
            this.actorEmail = _data["actorEmail"] !== undefined ? _data["actorEmail"] : null as any;
            if (Array.isArray(_data["changedFields"])) {
                this.changedFields = [] as any;
                for (let item of _data["changedFields"])
                    this.changedFields!.push(item);
            }
            else {
                this.changedFields = null as any;
            }
            this.attachmentObjectKey = _data["attachmentObjectKey"] !== undefined ? _data["attachmentObjectKey"] : null as any;
            this.aiPremiumEnabled = _data["aiPremiumEnabled"] !== undefined ? _data["aiPremiumEnabled"] : null as any;
            this.idempotencyKey = _data["idempotencyKey"] !== undefined ? _data["idempotencyKey"] : null as any;
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(AgentEventRoute.fromJS(item));
            }
            else {
                this.routes = null as any;
            }
        }
    }

    static fromJS(data: any): CrmEventData {
        data = typeof data === 'object' ? data : {};
        let result = new CrmEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["schemaVersion"] = this.schemaVersion !== undefined ? this.schemaVersion : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["carrierCompanyId"] = this.carrierCompanyId !== undefined ? this.carrierCompanyId : null as any;
        data["entityName"] = this.entityName !== undefined ? this.entityName : null as any;
        data["entityId"] = this.entityId !== undefined ? this.entityId : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["actorUserId"] = this.actorUserId !== undefined ? this.actorUserId : null as any;
        data["actorEmail"] = this.actorEmail !== undefined ? this.actorEmail : null as any;
        if (Array.isArray(this.changedFields)) {
            data["changedFields"] = [];
            for (let item of this.changedFields)
                data["changedFields"].push(item);
        }
        data["attachmentObjectKey"] = this.attachmentObjectKey !== undefined ? this.attachmentObjectKey : null as any;
        data["aiPremiumEnabled"] = this.aiPremiumEnabled !== undefined ? this.aiPremiumEnabled : null as any;
        data["idempotencyKey"] = this.idempotencyKey !== undefined ? this.idempotencyKey : null as any;
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICrmEventData {
    schemaVersion?: string | null;
    customerId?: number | null;
    claimId?: number | null;
    carrierCompanyId?: number | null;
    entityName?: string | null;
    entityId?: number;
    operation?: string | null;
    actorUserId?: number | null;
    actorEmail?: string | null;
    changedFields?: string[] | null;
    attachmentObjectKey?: string | null;
    aiPremiumEnabled?: boolean | null;
    idempotencyKey?: string | null;
    routes?: AgentEventRoute[] | null;

    [key: string]: any;
}

export class CrmEventEnvelope implements ICrmEventEnvelope {
    specversion?: string | null;
    id?: string | null;
    source?: string | null;
    type?: string | null;
    subject?: string | null;
    time?: DateTime;
    dataschema?: string | null;
    data?: CrmEventData | null;

    [key: string]: any;

    constructor(data?: ICrmEventEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.specversion = _data["specversion"] !== undefined ? _data["specversion"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : null as any;
            this.dataschema = _data["dataschema"] !== undefined ? _data["dataschema"] : null as any;
            this.data = _data["data"] ? CrmEventData.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): CrmEventEnvelope {
        data = typeof data === 'object' ? data : {};
        let result = new CrmEventEnvelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["specversion"] = this.specversion !== undefined ? this.specversion : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["time"] = this.time ? this.time.toString() : null as any;
        data["dataschema"] = this.dataschema !== undefined ? this.dataschema : null as any;
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface ICrmEventEnvelope {
    specversion?: string | null;
    id?: string | null;
    source?: string | null;
    type?: string | null;
    subject?: string | null;
    time?: DateTime;
    dataschema?: string | null;
    data?: CrmEventData | null;

    [key: string]: any;
}

export class CrmEventReconciliationEventResult implements ICrmEventReconciliationEventResult {
    eventId?: string;
    eventType?: string;
    subject?: string;
    customerId?: number | null;
    claimId?: number | null;
    operation?: string;
    occurredAtUtc?: DateTime;
    idempotencyKey?: string;
    status?: string;
    error?: string;

    [key: string]: any;

    constructor(data?: ICrmEventReconciliationEventResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null as any;
            this.eventType = _data["eventType"] !== undefined ? _data["eventType"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.occurredAtUtc = _data["occurredAtUtc"] ? DateTime.fromISO(_data["occurredAtUtc"].toString()) : null as any;
            this.idempotencyKey = _data["idempotencyKey"] !== undefined ? _data["idempotencyKey"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.error = _data["error"] !== undefined ? _data["error"] : null as any;
        }
    }

    static fromJS(data: any): CrmEventReconciliationEventResult {
        data = typeof data === 'object' ? data : {};
        let result = new CrmEventReconciliationEventResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["eventId"] = this.eventId !== undefined ? this.eventId : null as any;
        data["eventType"] = this.eventType !== undefined ? this.eventType : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["occurredAtUtc"] = this.occurredAtUtc ? this.occurredAtUtc.toString() : null as any;
        data["idempotencyKey"] = this.idempotencyKey !== undefined ? this.idempotencyKey : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["error"] = this.error !== undefined ? this.error : null as any;
        return data;
    }
}

export interface ICrmEventReconciliationEventResult {
    eventId?: string;
    eventType?: string;
    subject?: string;
    customerId?: number | null;
    claimId?: number | null;
    operation?: string;
    occurredAtUtc?: DateTime;
    idempotencyKey?: string;
    status?: string;
    error?: string;

    [key: string]: any;
}

export class CrmEventReconciliationRequest implements ICrmEventReconciliationRequest {
    fromUtc?: DateTime;
    toUtc?: DateTime;
    dryRun?: boolean;
    customerId?: number | null;
    claimId?: number | null;
    maxEvents?: number;
    operatorReason?: string;

    [key: string]: any;

    constructor(data?: ICrmEventReconciliationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fromUtc = _data["fromUtc"] ? DateTime.fromISO(_data["fromUtc"].toString()) : null as any;
            this.toUtc = _data["toUtc"] ? DateTime.fromISO(_data["toUtc"].toString()) : null as any;
            this.dryRun = _data["dryRun"] !== undefined ? _data["dryRun"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.maxEvents = _data["maxEvents"] !== undefined ? _data["maxEvents"] : null as any;
            this.operatorReason = _data["operatorReason"] !== undefined ? _data["operatorReason"] : null as any;
        }
    }

    static fromJS(data: any): CrmEventReconciliationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CrmEventReconciliationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fromUtc"] = this.fromUtc ? this.fromUtc.toString() : null as any;
        data["toUtc"] = this.toUtc ? this.toUtc.toString() : null as any;
        data["dryRun"] = this.dryRun !== undefined ? this.dryRun : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["maxEvents"] = this.maxEvents !== undefined ? this.maxEvents : null as any;
        data["operatorReason"] = this.operatorReason !== undefined ? this.operatorReason : null as any;
        return data;
    }
}

export interface ICrmEventReconciliationRequest {
    fromUtc?: DateTime;
    toUtc?: DateTime;
    dryRun?: boolean;
    customerId?: number | null;
    claimId?: number | null;
    maxEvents?: number;
    operatorReason?: string;

    [key: string]: any;
}

export class CrmEventReconciliationResult implements ICrmEventReconciliationResult {
    reconciliationRunId?: string;
    fromUtc?: DateTime;
    toUtc?: DateTime;
    dryRun?: boolean;
    customerId?: number | null;
    claimId?: number | null;
    operatorReason?: string;
    discoveredCount?: number;
    plannedCount?: number;
    publishedCount?: number;
    failedCount?: number;
    skippedCount?: number;
    truncated?: boolean;
    events?: CrmEventReconciliationEventResult[];

    [key: string]: any;

    constructor(data?: ICrmEventReconciliationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reconciliationRunId = _data["reconciliationRunId"] !== undefined ? _data["reconciliationRunId"] : null as any;
            this.fromUtc = _data["fromUtc"] ? DateTime.fromISO(_data["fromUtc"].toString()) : null as any;
            this.toUtc = _data["toUtc"] ? DateTime.fromISO(_data["toUtc"].toString()) : null as any;
            this.dryRun = _data["dryRun"] !== undefined ? _data["dryRun"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.operatorReason = _data["operatorReason"] !== undefined ? _data["operatorReason"] : null as any;
            this.discoveredCount = _data["discoveredCount"] !== undefined ? _data["discoveredCount"] : null as any;
            this.plannedCount = _data["plannedCount"] !== undefined ? _data["plannedCount"] : null as any;
            this.publishedCount = _data["publishedCount"] !== undefined ? _data["publishedCount"] : null as any;
            this.failedCount = _data["failedCount"] !== undefined ? _data["failedCount"] : null as any;
            this.skippedCount = _data["skippedCount"] !== undefined ? _data["skippedCount"] : null as any;
            this.truncated = _data["truncated"] !== undefined ? _data["truncated"] : null as any;
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(CrmEventReconciliationEventResult.fromJS(item));
            }
            else {
                this.events = null as any;
            }
        }
    }

    static fromJS(data: any): CrmEventReconciliationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CrmEventReconciliationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reconciliationRunId"] = this.reconciliationRunId !== undefined ? this.reconciliationRunId : null as any;
        data["fromUtc"] = this.fromUtc ? this.fromUtc.toString() : null as any;
        data["toUtc"] = this.toUtc ? this.toUtc.toString() : null as any;
        data["dryRun"] = this.dryRun !== undefined ? this.dryRun : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["operatorReason"] = this.operatorReason !== undefined ? this.operatorReason : null as any;
        data["discoveredCount"] = this.discoveredCount !== undefined ? this.discoveredCount : null as any;
        data["plannedCount"] = this.plannedCount !== undefined ? this.plannedCount : null as any;
        data["publishedCount"] = this.publishedCount !== undefined ? this.publishedCount : null as any;
        data["failedCount"] = this.failedCount !== undefined ? this.failedCount : null as any;
        data["skippedCount"] = this.skippedCount !== undefined ? this.skippedCount : null as any;
        data["truncated"] = this.truncated !== undefined ? this.truncated : null as any;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICrmEventReconciliationResult {
    reconciliationRunId?: string;
    fromUtc?: DateTime;
    toUtc?: DateTime;
    dryRun?: boolean;
    customerId?: number | null;
    claimId?: number | null;
    operatorReason?: string;
    discoveredCount?: number;
    plannedCount?: number;
    publishedCount?: number;
    failedCount?: number;
    skippedCount?: number;
    truncated?: boolean;
    events?: CrmEventReconciliationEventResult[];

    [key: string]: any;
}

export class JsonElement implements IJsonElement {

    [key: string]: any;

    constructor(data?: IJsonElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): JsonElement {
        data = typeof data === 'object' ? data : {};
        let result = new JsonElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IJsonElement {

    [key: string]: any;
}

export enum PriorityEnum {
    Low = "Low",
    Normal = "Normal",
    High = "High",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null as any;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class SelectOptionDto implements ISelectOptionDto {
    id?: number | null;
    fieldId?: number;
    value!: string;
    label?: string;
    isSystem?: boolean | null;

    [key: string]: any;

    constructor(data?: ISelectOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fieldId = _data["fieldId"] !== undefined ? _data["fieldId"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.isSystem = _data["isSystem"] !== undefined ? _data["isSystem"] : null as any;
        }
    }

    static fromJS(data: any): SelectOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fieldId"] = this.fieldId !== undefined ? this.fieldId : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["isSystem"] = this.isSystem !== undefined ? this.isSystem : null as any;
        return data;
    }
}

export interface ISelectOptionDto {
    id?: number | null;
    fieldId?: number;
    value: string;
    label?: string;
    isSystem?: boolean | null;

    [key: string]: any;
}

export enum TaskParticipantRoleEnum {
    Primary = "Primary",
    Collaborator = "Collaborator",
    Watcher = "Watcher",
}

export enum TaskStatusEnum {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    Blocked = "Blocked",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export enum UserInviteTypeEnum {
    Internal = "Internal",
    External = "External",
}

export class UserType implements IUserType {

    [key: string]: any;

    constructor(data?: IUserType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): UserType {
        data = typeof data === 'object' ? data : {};
        let result = new UserType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IUserType {

    [key: string]: any;
}

export class DefaultCommissionType implements IDefaultCommissionType {

    [key: string]: any;

    constructor(data?: IDefaultCommissionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): DefaultCommissionType {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultCommissionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IDefaultCommissionType {

    [key: string]: any;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}